import type { Namespace } from '@govard/i18n-core';

// Complete English counterpart of the legacy CRM catalog.
export const crmEn: Namespace = {
  'chat.planner_first.read_failed':
    'The complete requested data could not be verified and read. No partial result is shown. Clarify the request or try again later.',
  'chat.planner_first.single_write_failed':
    'The complete action could not be verified safely. Nothing was executed. Clarify the request or try again later.',
  'chat.planner_first.batch_failed':
    'The entire batch could not be verified safely. No actions were prepared or executed. Clarify the request or try again later.',
  'chat.planner_first.unclassified_failed':
    'The complete request could not be verified safely. Nothing was executed. Clarify the request or try again later.',
  'chat.planner_first.read_not_found':
    'No matching record was found. Check the name or specify a different one.',
  'chat.planner_first.read_too_many':
    'Too many records match. Narrow the name before selecting a record.',
  'chat.planner_first.read_choose':
    'Several records match. Choose a record by its number or exact name:',
  'chat.planner_first.read_confirm': 'Found deal «{label}» — is this the one?',
  'chat.planner_first.read_selection_unavailable':
    'The saved choice is unavailable or has changed. Repeat the original request to get a current list.',

  'ai_chat.simple_missing.note_target': 'contact or deal',
  'chat.crm_read.field.contacts_count': 'Contact count',
  'ai_chat.simple_missing.message':
    'Clarify the missing fields: {fields}. These details are needed to complete the request safely.',
  'ai_chat.simple_missing.description': 'description',
  'ai_chat.simple_missing.task': 'task',
  'ai_chat.simple_missing.contact': 'contact',
  'ai_chat.simple_missing.company': 'company',
  'ai_chat.simple_missing.deal': 'deal',
  'ai_chat.simple_missing.status': 'status',
  'ai_chat.simple_missing.first_name': 'contact first name',
  'ai_chat.simple_missing.phone_or_email': 'contact phone number or email',
  'ai_chat.simple_missing.note_body': 'note text',
  'ai_chat.simple_missing.stage': 'deal stage',
  'ai_chat.simple_missing.relation': 'linked record',
  'ai_chat.normalization_field.message':
    'The format of {field} could not be understood. Please provide it more precisely.',
  'ai_chat.normalization_field.dueAt': 'date and time',
  'ai_chat.normalization_field.startsAt': 'start date and time',
  'ai_chat.normalization_field.endsAt': 'end date and time',
  'ai_chat.normalization_field.amount': 'amount',
  'ai_chat.normalization_field.title': 'title',
  'ai_chat.normalization_field.specialTarget': 'the required record',
  'ai_chat.normalization_field.phone': 'phone number',
  'ai_chat.normalization_field.email': 'email address',
  'ai_chat.normalization_field.contacts': 'contact details',
  'ai_chat.normalization_field.operations': 'the requested actions',
  'chat.simple.create_task': 'Create a task',
  'chat.simple.update_task': 'Update a task',
  'chat.simple.create_deal': 'Create a deal',
  'chat.simple.search_contacts': 'Find contacts',
  'chat.simple.read_contact': 'Show contact',
  'chat.simple.search_companies': 'Find companies',
  'chat.simple.read_company': 'Show company',
  'chat.simple.disabled': 'This command execution path is not enabled for this workspace yet.',
  'chat.simple.time_required':
    'Specify the exact time for the task. The date from the original request is preserved.',
  'ai_chat.quota.exceeded':
    'Your monthly AI token limit has been reached. Please try again next month.',
  'ai_chat.quota.storage_exceeded':
    'Your plan storage limit has been reached. Delete files or contact your administrator.',
  'ai_chat.history.load_earlier': 'Load earlier',
  'ai_chat.history.load_error': 'Could not load earlier messages. Please try again.',
  'ai_chat.handoff.invalid_command': 'Clarify the action parameters and try again.',
  'ai_chat.handoff.clarify_deal':
    'The selected deal could not be found in this workspace. Select the deal again.',
  'ai_chat.handoff.select_note': 'Select a note to extract tasks from',
  'ai_chat.handoff.clarify_note':
    'The selected note could not be read. Select an available note again.',
  'ai_chat.handoff.clarify_selection':
    'The selected records are no longer available in this briefing. Refresh the briefing and select the records again.',
  'ai_chat.project_delete_impact.title': 'Project',
  'ai_chat.project_delete_impact.unchanged':
    'This is an explanation only: the project and linked data have not been changed.',
  'ai_chat.project_delete_impact.effects': 'If the project is deleted:',
  'ai_chat.project_delete_impact.project': 'The project will disappear from active lists.',
  'ai_chat.project_delete_impact.children':
    'Tasks and calendar events will remain, but their project links will be removed.',
  'ai_chat.project_delete_impact.notes':
    'Project note links and memberships will be removed. The notes themselves will remain.',
  'ai_chat.project_delete_impact.restore': 'User-facing project restoration is not supported.',
  'ai_chat.project_delete_impact.counts': 'Currently linked to this project:',
  'ai_chat.project_delete_impact.tasks': 'Tasks: {count}',
  'ai_chat.project_delete_impact.meetings': 'Calendar events: {count}',
  'ai_chat.project_delete_impact.note_links': 'Note links: {count}',
  'ai_chat.project_delete_impact.members': 'Members: {count}',
  'ai_chat.project_delete_impact.unavailable':
    'The task count is unavailable with your permissions.',
  'ai_chat.project_delete_impact.status.planned': 'Planned',
  'ai_chat.project_delete_impact.status.active': 'Active',
  'ai_chat.project_delete_impact.status.on_hold': 'On hold',
  'ai_chat.project_delete_impact.status.completed': 'Completed',
  'ai_chat.project_delete_impact.status.cancelled': 'Cancelled',
  'ai_chat.memory_delete.clarification':
    'The saved preference and its current version could not be identified unambiguously. Specify which fact to forget. No CRM data was changed.',
  'deal_detail.probability': 'Close probability',
  'deal_detail.health': 'Deal health',
  'deal_detail.health_short': 'Health',
  'deal_detail.activity_short': 'Activity',
  'deal_detail.tasks_short': 'Tasks',
  'deal_detail.task_counts_hint': 'open / overdue',
  'deal_detail.all_stage_changes': 'All stage changes',
  'deal_detail.summary': 'Summary',
  'deal_detail.details': 'Details',
  'deal_detail.tasks_open_overdue': 'Tasks: open / overdue',
  'deal_detail.step_overdue_since': 'Overdue since {date}',
  'enum.deal_stage.new': 'New',
  'enum.deal_stage.contacted': 'Contacted',
  'enum.deal_stage.negotiation': 'Negotiation',
  'enum.deal_stage.won': 'Won',
  'enum.deal_stage.lost': 'Lost',
  'deal_detail.next_step': 'Next contact',
  'deal_detail.not_planned': 'Not scheduled',
  'deal_detail.assign_contact': 'Schedule',
  'deal_detail.change_contact': 'Change',
  'deal_detail.clear': 'Clear',
  'deal_detail.next_contact_saved': 'Next contact updated',
  'deal_detail.preset_today': 'Today 18:00',
  'deal_detail.preset_tomorrow': 'Tomorrow 10:00',
  'deal_detail.preset_three_days': 'In 3 days',
  'deal_detail.preset_week': 'In a week',
  'entity_detail.relative_short.now': 'just now',
  'entity_detail.relative_short.minute_past': '{count}m ago',
  'entity_detail.relative_short.hour_past': '{count}h ago',
  'entity_detail.relative_short.day_past': '{count}d ago',
  'entity_detail.relative_short.minute_future': 'in {count}m',
  'entity_detail.relative_short.hour_future': 'in {count}h',
  'entity_detail.relative_short.day_future': 'in {count}d',
  'deal_detail.plan': 'Plan',
  'deal_detail.plan_step': 'Plan next step',
  'deal_detail.stage': 'Stage',
  'deal_detail.company': 'Company',
  'deal_detail.delete': 'Delete deal',
  'deal_detail.pipeline': 'Deal stages',
  'deal_detail.won': 'Won',
  'deal_detail.lost': 'Lost',
  'deal_detail.move_confirm': 'Move to “{stage}”?',
  'deal_detail.stage_changed': 'Stage changed: {stage}',
  'deal_detail.loss_reason': 'Reason for loss',
  'deal_detail.stage_history': 'Stage changes',
  'deal_detail.history_all': 'All',
  'deal_detail.history_stages': 'Stages',
  'deal_detail.history_tasks': 'Tasks',
  'deal_detail.history_notes': 'Notes',
  'deal_detail.replace_company': 'Replace the company with the contact’s company?',
  'deal_detail.company_mismatch':
    'Company is not linked to the contact — the contact will be cleared',
  'deal_detail.other_source': 'Other…',
  'deal_detail.partial_create':
    'The deal was created, but the additional fields were not saved. Try saving again.',
  'deal_detail.risk_healthy': 'Low risk',
  'deal_detail.risk_attention': 'Medium risk',
  'deal_detail.risk_critical': 'High risk',
  'deal_detail.event_stage': 'Stage',
  'deal_detail.event_task': 'Task',
  'deal_detail.event_note': 'Note',
  'deal_detail.event_meeting': 'Meeting',
  'deal_detail.event_file': 'File',
  'deal_detail.event_other': 'Activity',
  'deal_detail.reason_missing_next_activity': 'No next contact scheduled',
  'deal_detail.reason_overdue_next_activity': 'Next contact is overdue',
  'deal_detail.reason_stale_activity': 'No recent activity',
  'deal_detail.reason_stage_age_over_norm': 'Deal has stayed in the stage too long',
  'deal_detail.reason_qualification_gaps': 'Qualification data is missing',
  'deal_detail.reason_overdue_task': 'There are overdue tasks',
  'deal_detail.reason_stage_new': 'Initial stage',
  'deal_detail.reason_stage_contacted': 'Contact established',
  'deal_detail.reason_stage_negotiation': 'Negotiation',
  'deal_detail.reason_zero_amount': 'Amount is not specified',
  'deal_detail.reason_closed_won': 'Deal won',
  'deal_detail.reason_closed_lost': 'Deal lost',
  'enum.tag.cold': 'Cold',
  'enum.tag.warm': 'Warm',
  'enum.tag.new': 'New',
  'enum.tag.vip': 'VIP',
  'enum.tag.phone-only': 'Phone only',
  'enum.tag.stale': 'Stale',
  'enum.tag.high-value': 'High value',
  'enum.tag.lost-price': 'Lost: price',
  'enum.contact_source.website': 'Website',
  'enum.contact_source.instagram': 'Instagram',
  'enum.contact_source.referral': 'Referral',
  'enum.contact_source.phone': 'Phone',
  'enum.contact_source.telegram': 'Telegram',
  'entity_detail.tags': 'Tags',
  'entity_detail.company_edit': 'Change company',
  'entity_detail.add': 'Add',
  'entity_detail.note_shortcut': 'Ctrl+Enter — save quickly',
  'entity_detail.delete_contact': 'Delete contact',
  'entity_detail.delete_note': 'Delete note',
  'entity_detail.sort': 'Sort',
  'entity_detail.sort_due': 'By due date',
  'entity_detail.sort_priority': 'By priority',
  'entity_detail.sort_title': 'By name',
  'entity_detail.sort_amount': 'By amount',
  'entity_detail.sort_stage': 'By stage',
  'entity_detail.sort_updated': 'By updated date',
  'entity_detail.task_status': 'Status of task “{title}”',
  'entity_detail.meeting_unmarked': 'Unmarked',
  'entity_detail.download_ics': 'Download .ics',
  'entity_detail.cancel_meeting': 'Cancel meeting',
  'entity_detail.cancel_meeting_confirm': 'Cancel meeting?',
  'entity_detail.all_tags': 'All tags',
  'entity_detail.more_actions': 'More actions',
  'entity_detail.row_actions': 'Actions for “{title}”',
  'entity_detail.copy': 'Copy',
  'entity_detail.copied': 'Copied',
  'entity_detail.interaction_call': 'Call',
  'entity_detail.interaction_email': 'Email',
  'entity_detail.interaction_meeting': 'Meeting',
  'entity_detail.interaction_note': 'Note',
  'entity_detail.interaction_sms': 'SMS',
  'entity_detail.interaction_in_app': 'Message',
  'entity_detail.confirm': 'Confirm',
  'entity_detail.cancel': 'Cancel',
  'entity_detail.tabs': 'Record sections',
  'entity_detail.more_tabs': 'More',
  'entity_detail.overview': 'Overview',
  'entity_detail.summary': 'Summary',
  'entity_detail.links': 'Links',
  'entity_detail.open_chat': 'Open AI chat',
  'entity_detail.edit_document_text': 'Edit text →',
  'entity_detail.deals': 'Deals',
  'entity_detail.tasks': 'Tasks',
  'entity_detail.meetings': 'Meetings',
  'entity_detail.notes': 'Notes',
  'entity_detail.documents': 'Documents',
  'entity_detail.files': 'Files',
  'entity_detail.history': 'History',
  'entity_detail.today': 'Today',
  'entity_detail.yesterday': 'Yesterday',
  'entity_detail.overdue_days': '{count} days overdue',
  'entity_detail.overdue_since': 'Overdue since {date}',
  'entity_detail.overdue_tasks': 'Overdue ({count})',
  'entity_detail.all_tasks': 'All tasks',
  'entity_detail.show_more': 'Show more',
  'entity_detail.show_less': 'Show less',
  'entity_detail.load_error': 'Could not load data',
  'entity_detail.save_error': 'Could not save changes',
  'entity_detail.save': 'Save',
  'entity_detail.new_note': 'Write a note…',
  'entity_detail.empty_notes': 'No notes yet',
  'entity_detail.empty_history': 'No activity yet',
  'entity_detail.empty_deals': 'No related deals yet',
  'entity_detail.empty_tasks': 'No tasks yet',
  'entity_detail.empty_meetings': 'No meetings yet',
  'entity_detail.empty_documents': 'No documents yet',
  'entity_detail.empty_files': 'No files yet',
  'entity_detail.empty_overview': 'No description, planned actions or history yet',
  'entity_detail.add_deal': 'Deal',
  'entity_detail.add_task': 'Task',
  'entity_detail.add_meeting': 'Meeting',
  'entity_detail.add_document': 'Document',
  'entity_detail.add_file': 'Upload file',
  'entity_detail.add_interaction': 'Log interaction',
  'entity_detail.edit': 'Edit',
  'entity_detail.delete': 'Delete',
  'entity_detail.delete_confirm': 'Delete this record?',
  'entity_detail.delete_description': 'The record will be deleted. This cannot be undone.',
  'entity_detail.download': 'Download',
  'entity_detail.search': 'Search by title',
  'entity_detail.active_deals': 'Active deals',
  'entity_detail.last_activity': 'Last activity',
  'entity_detail.details': 'Contact details',
  'entity_detail.description': 'Description',
  'entity_detail.next_task': 'Next task',
  'entity_detail.next_meeting': 'Next meeting',
  'entity_detail.recent_history': 'Recent activity',
  'entity_detail.created': 'Created',
  'entity_detail.updated': 'Updated',
  'entity_detail.role': 'Job title',
  'entity_detail.completed_tasks': 'Completed tasks ({count})',
  'entity_detail.complete_task': 'Complete task “{title}”',
  'entity_detail.reopen_task': 'Reopen task “{title}”',
  'entity_detail.task_completed': 'Task completed',
  'entity_detail.undo': 'Undo',
  'entity_detail.contact_unavailable': 'Contact not found',
  'entity_detail.write': 'Write',
  'entity_detail.call': 'Call',
  'entity_detail.task_todo': 'To do',
  'entity_detail.task_in_progress': 'In progress',
  'entity_detail.task_blocked': 'Blocked',
  'entity_detail.task_done': 'Completed',
  'entity_detail.task_cancelled': 'Cancelled',
  'entity_detail.meeting_scheduled': 'Scheduled',
  'entity_detail.meeting_completed': 'Completed',
  'entity_detail.meeting_cancelled': 'Cancelled',
  'ai_chat.memory_update.clarification':
    'The saved preference and its current version could not be identified unambiguously. Specify which fact should change. No CRM data was changed.',
  'ai_chat.proposal.title': 'Editable task proposal',
  'ai_chat.proposal.create_effect': 'Confirming creates this task',
  'ai_chat.proposal.update_effect': 'Confirming updates this task',
  'ai_chat.proposal.revision': 'Revision {number}',
  'ai_chat.proposal.task_title': 'Title',
  'ai_chat.proposal.description': 'Description',
  'ai_chat.proposal.due_at': 'Due date and time',
  'ai_chat.proposal.priority': 'Priority',
  'ai_chat.proposal.priority_low': 'Low',
  'ai_chat.proposal.priority_medium': 'Medium',
  'ai_chat.proposal.priority_high': 'High',
  'ai_chat.proposal.priority_urgent': 'Urgent',
  'ai_chat.proposal.assignee': 'Assignee',
  'ai_chat.proposal.unassigned': 'Unassigned',
  'ai_chat.proposal.save': 'Save proposal',
  'ai_chat.proposal.unsaved': 'Save changes before confirming',
  'ai_chat.proposal.save_error': 'Could not save the proposal. Refresh and try again.',
  'ai_chat.proposal.load_error': 'Could not verify this proposal. Refresh before confirming.',
  'ai_chat.proposal.conflict': 'The proposal changed. Refresh before editing again.',
  'ai_chat.proposal.invalid_date': 'Enter a valid due date and time.',
  'ai_chat.proposal.read_only': 'This proposal can no longer be edited or confirmed.',
  'ai_chat.proposal.saved_without_approval':
    'Changes were saved, but confirmation is unavailable. Ask in chat to resubmit this proposal.',
  'common.cancel': 'Cancel',
  // List-page chrome for the sections brought to the shared list standard.
  'meetings.list.view_label': 'View mode',
  'meetings.list.refresh': 'Refresh',
  'meetings.list.search_label': 'Search meetings',
  'meetings.list.status_label': 'Status filter',
  'notes.new': 'New note',
  'notes.list.search_label': 'Search notes',
  'settings.field.email': 'Email',
  'settings.field.workspace_id': 'Workspace ID',
  'settings.field.feature_flags': 'Feature flags',
  // Count nouns for list subtitles — plural shapes so «1 document» / «3 documents»
  // read correctly (see i18n.tc).
  'counts.documents': { one: 'document', other: 'documents' },
  'counts.projects': { one: 'project', other: 'projects' },
  'counts.meetings': { one: 'meeting', other: 'meetings' },
  'counts.notes': { one: 'note', other: 'notes' },
  'counts.templates': { one: 'template', other: 'templates' },
  'counts.approvals': { one: 'record', other: 'records' },
  'counts.hot_leads': { one: 'deal', other: 'deals' },
  'nav.dashboard': 'Home',
  'nav.chat': 'Chat',
  'nav.deals': 'Deals',
  'nav.tasks': 'Tasks',
  'nav.calendar': 'Calendar',
  'calendar.title': 'Calendar',
  'calendar.subtitle': 'Week planner: tasks, meetings, Telegram leads and deal deadlines.',
  'calendar.view.day': 'Day',
  'calendar.view.week': 'Week',
  'calendar.view.list': 'List',
  'calendar.nav.today': 'Today',
  'calendar.nav.prev': 'Previous period',
  'calendar.nav.next': 'Next period',
  'calendar.nav.prev_hint': 'Previous {period} (←)',
  'calendar.nav.next_hint': 'Next {period} (→)',
  'calendar.nav.today_hint': 'Current week (T)',
  'calendar.period.day': 'day',
  'calendar.period.week': 'week',
  'calendar.quick_create.task': 'Task',
  'calendar.quick_create.meeting': 'Meeting',
  'calendar.quick_create.add': 'Add an entry on {date}',
  'calendar.overflow.title': 'All events of the day',
  'calendar.filter.task': 'Tasks',
  'calendar.filter.meeting': 'Meetings',
  'calendar.filter.tg': 'Telegram',
  'calendar.filter.deadline': 'Deadlines',
  'calendar.filter.generic': 'Records',
  'calendar.zone.all_day': 'All day',
  'calendar.day_sections.timed': 'Timed',
  'calendar.empty_day': 'No events',
  'calendar.empty_day_view': 'No events for this day',
  'calendar.free_day': 'Free',
  'calendar.more_events': '+{count} more',
  'calendar.overdue': 'Overdue',
  'calendar.quick_status_done': 'Mark as done',
  'calendar.quick_status_todo': 'Reopen task',
  'calendar.refresh': 'Refresh',
  'calendar.load_error': 'Could not load the calendar',
  'calendar.source_error.tasks': 'Could not load tasks',
  'calendar.source_error.meetings': 'Could not load meetings',
  'calendar.source_error.overdue': 'Could not load overdue tasks',
  'calendar.source_error.deals': 'Could not load deal deadlines',
  'calendar.source_error.telegram': 'Telegram leads did not load',
  'calendar.source_error.hint': 'The rest of the calendar is shown',
  'calendar.list.count': {
    one: '{count} event',
    other: '{count} events',
  },
  'calendar.list.empty': 'empty',
  'calendar.list.no_events': 'no events',
  'nav.projects': 'Projects',
  'nav.contacts': 'Contacts',
  'nav.companies': 'Companies',
  'nav.notes': 'Notes',
  'nav.meetings': 'Meetings',
  'nav.approvals': 'Approvals',
  'nav.telegram_candidates': 'From Telegram',
  'nav.telegram_operations': 'Telegram operations',
  'telegram_operations.title': 'Telegram operations',
  'telegram_operations.subtitle': 'Content-free delivery, queue and privacy signals',
  'telegram_operations.window': 'Metrics window',
  'telegram_operations.windows.1h': 'Last hour',
  'telegram_operations.windows.24h': 'Last 24 hours',
  'telegram_operations.windows.7d': 'Last 7 days',
  'telegram_operations.load_error': 'Could not load Telegram operations',
  'telegram_operations.forbidden':
    'Only workspace owners and administrators can view Telegram operations.',
  'telegram_operations.ingress': 'Inbound events',
  'telegram_operations.delivery': 'Deliveries',
  'telegram_operations.inbound_due': 'Inbound backlog',
  'telegram_operations.delivery_due': 'Delivery backlog',
  'telegram_operations.delivery_success': 'Eligible delivery success',
  'telegram_operations.ambiguous': 'Ambiguous deliveries',
  'telegram_operations.ingress_p95': 'Inbound processing p95',
  'telegram_operations.delivery_p95': 'Delivery latency p95',
  'telegram_operations.rollout': 'Rollout controls',
  'telegram_operations.connections': 'Connections',
  'telegram_operations.no_connections': 'No Telegram connection',
  'telegram_operations.ref_unavailable': 'Reference unavailable while integration is disabled',
  'telegram_operations.connection_status.provisioning': 'Provisioning',
  'telegram_operations.connection_status.active': 'Active',
  'telegram_operations.connection_status.suspended': 'Suspended',
  'telegram_operations.connection_status.revoked': 'Revoked',
  'telegram_operations.recent': 'Recent content-free delivery evidence',
  'telegram_operations.empty': 'No delivery evidence in this window',
  'telegram_operations.ref': 'Reference',
  'telegram_operations.kind': 'Kind',
  'telegram_operations.status': 'Status',
  'telegram_operations.attempt': 'Attempt',
  'telegram_operations.duration': 'Duration',
  'telegram_operations.outcome': 'Outcome',
  'telegram_operations.on': 'on',
  'telegram_operations.off': 'off',
  'telegram_operations.flags.beta': 'Telegram beta',
  'telegram_operations.flags.inboundWorker': 'Inbound worker',
  'telegram_operations.flags.deliveryWorker': 'Delivery worker',
  'telegram_operations.flags.groupExtraction': 'Group extraction',
  'telegram_operations.flags.approvalResults': 'Approval results',
  'telegram_operations.flags.dailyDigest': 'Daily digest',
  'telegram_operations.alerts.inbound_backlog': 'Inbound queue exceeds the operational threshold.',
  'telegram_operations.alerts.delivery_backlog':
    'Delivery queue exceeds the operational threshold.',
  'telegram_operations.alerts.delivery_error_budget': 'Delivery terminal error budget is exceeded.',
  'telegram_operations.statuses.queued': 'Queued',
  'telegram_operations.statuses.claimed': 'Claimed',
  'telegram_operations.statuses.sending': 'Sending',
  'telegram_operations.statuses.retry_wait': 'Waiting to retry',
  'telegram_operations.statuses.sent': 'Sent',
  'telegram_operations.statuses.ambiguous': 'Ambiguous',
  'telegram_operations.statuses.permanent_failed': 'Permanently failed',
  'telegram_operations.statuses.cancelled': 'Cancelled',
  'telegram_operations.kinds.private_agent_response': 'Private assistant response',
  'telegram_operations.kinds.private_approval_presentation': 'Private approval',
  'telegram_operations.kinds.group_disclosure': 'Group disclosure',
  'telegram_operations.kinds.group_status': 'Group status',
  'telegram_operations.kinds.group_acknowledgement': 'Group acknowledgement',
  'telegram_operations.kinds.private_approval_result': 'Approval result',
  'telegram_operations.kinds.private_daily_digest': 'Daily digest',
  'telegram_operations.outcomes.subscription_disabled': 'Subscription disabled',
  'telegram_operations.outcomes.authority_unavailable': 'Authority unavailable',
  'telegram_operations.outcomes.provider_retryable': 'Provider retryable error',
  'telegram_operations.outcomes.provider_recipient_unavailable': 'Recipient unavailable',
  'telegram_operations.outcomes.privacy_revoked': 'Privacy access revoked',
  'telegram_operations.outcomes.other': 'Other terminal outcome',
  'settings.telegram.privacy_title': 'Your Telegram data',
  'settings.telegram.privacy_description':
    'Export or delete transport data from your historical private Telegram link. CRM records you approved are not deleted.',
  'settings.telegram.export_private': 'Export my Telegram data',
  'settings.telegram.delete_private': 'Delete my Telegram data',
  'settings.telegram.export_title': 'Export private Telegram data',
  'settings.telegram.delete_title': 'Delete private Telegram data',
  'settings.telegram.export_description':
    'The export is generated for this authenticated request and is not published as a persistent file.',
  'settings.telegram.delete_warning':
    'Transport content and private message copies will be removed. Approved CRM records remain.',
  'settings.telegram.confirm_phrase': 'DELETE TELEGRAM DATA',
  'settings.telegram.type_phrase': 'Type “{phrase}” to confirm.',
  'settings.telegram.confirmation': 'Confirmation phrase',
  'settings.telegram.confirm_action': 'Confirm',
  'settings.telegram.link_title': 'Personal Telegram assistant',
  'settings.telegram.link_description':
    'Connect your Telegram account to this CRM workspace. The one-time link expires in 10 minutes.',
  'settings.telegram.link_loading': 'Loading Telegram connection',
  'settings.tabs.integrations': 'Integrations',
  'settings.calendars.title': 'External calendars',
  'settings.calendars.description':
    'Two-way meeting sync with Google Calendar and Outlook. Only an owner or admin can connect and disconnect.',
  'settings.calendars.unavailable': 'External calendar sync is disabled for this workspace.',
  'settings.calendars.loading': 'Loading calendar connections',
  'settings.calendars.load_error': 'Could not load calendar connections',
  'settings.calendars.provider_google': 'Google Calendar',
  'settings.calendars.provider_outlook': 'Outlook',
  'settings.calendars.connect_google': 'Connect Google Calendar',
  'settings.calendars.connect_outlook': 'Connect Outlook',
  'settings.calendars.empty': 'No calendar is connected yet.',
  'settings.calendars.error': 'Could not change the calendar connection',
  'settings.calendars.status_active': 'Syncing',
  'settings.calendars.status_suspended': 'Reconnect required',
  'settings.calendars.status_error': 'Sync error',
  'settings.calendars.status_revoked': 'Disconnected',
  'settings.calendars.last_sync': 'Last sync',
  'settings.calendars.never_synced': 'not synced yet',
  'settings.calendars.disconnect': 'Disconnect',
  'settings.calendars.disconnect_title': 'Disconnect the calendar?',
  'settings.calendars.disconnect_description':
    'Sync stops. Meetings stay in the CRM; links to the external calendar are removed.',
  'settings.calendars.disconnect_confirm': 'Disconnect',
  'settings.telegram.link_load_error': 'Could not check the Telegram connection',
  'settings.telegram.link_active': 'Telegram is connected',
  'settings.telegram.link_active_description':
    'You can message the bot and receive CRM assistant replies in a private chat.',
  'settings.telegram.link_suspended':
    'The connection is stopped. Reconnecting requires a new one-time link.',
  'settings.telegram.connect': 'Connect Telegram',
  'settings.telegram.reconnect': 'Connect again',
  'settings.telegram.disconnect': 'Disconnect Telegram',
  'settings.telegram.disconnect_title': 'Disconnect personal Telegram?',
  'settings.telegram.disconnect_description':
    'The bot will stop accepting your messages until you reconnect.',
  'settings.telegram.disconnect_confirm': 'Disconnect',
  'settings.telegram.link_error': 'Could not update the Telegram connection',
  'telegram_candidates.page_title': 'Telegram candidates',
  'telegram_candidates.subtitle': '{count} to review',
  'telegram_candidates.empty': 'No new candidates',
  'telegram_candidates.load_error': 'Could not load candidates',
  'telegram_candidates.confidence': 'Confidence: {value}%',
  'telegram_candidates.source': 'Source message',
  'telegram_candidates.source_unavailable': 'Source text is unavailable',
  'telegram_candidates.title': 'Title',
  'telegram_candidates.description': 'Description',
  'telegram_candidates.body': 'Text',
  'telegram_candidates.due_at': 'Due date (ISO)',
  'telegram_candidates.contact': 'Contact',
  'telegram_candidates.interaction_type': 'Interaction type',
  'telegram_candidates.subject': 'Subject',
  'telegram_candidates.confirm_changes': 'Confirm edits',
  'telegram_candidates.approve': 'Create in CRM',
  'telegram_candidates.reject': 'Reject',
  'telegram_candidates.needs_context': 'Needs context',
  'telegram_candidates.created': 'CRM record created',
  'telegram_candidates.type.note': 'Note',
  'telegram_candidates.type.task': 'Task',
  'telegram_candidates.type.contact_interaction': 'Contact interaction',
  'telegram_candidates.status.pending': 'Pending review',
  'telegram_candidates.status.needs_context': 'Needs context',
  'telegram_candidates.status.stale': 'Source changed',
  'telegram_candidates.status.rejected': 'Rejected',
  'telegram_candidates.status.expired': 'Expired',
  'telegram_candidates.status.succeeded': 'Created in CRM',
  'telegram_candidates.interaction.call': 'Call',
  'telegram_candidates.interaction.email': 'Email',
  'telegram_candidates.interaction.meeting': 'Meeting',
  'telegram_candidates.interaction.note': 'Note',
  'telegram_candidates.interaction.sms': 'SMS',
  'telegram_candidates.interaction.in_app': 'In app',
  'telegram_candidates.type.contact': 'Contact',
  'telegram_candidates.contact_create_new': 'Create a new contact',
  'telegram_candidates.first_name': 'First name',
  'telegram_candidates.last_name': 'Last name',
  'telegram_candidates.phone': 'Phone',
  'telegram_candidates.email': 'Email',
  'telegram_candidates.create_deal': 'Create a deal',
  'telegram_candidates.deal_title': 'Deal title',
  'telegram_candidates.deal_amount': 'Amount',
  'telegram_candidates.duplicate_title': 'Existing contact found',
  'telegram_candidates.duplicate_description':
    'Contact “{name}” already exists in the CRM. Link the candidate to it instead of creating a duplicate.',
  'telegram_candidates.duplicate_link': 'Link the existing contact',
  'telegram_candidates.result_contact': 'Contact',
  'telegram_candidates.result_deal': 'Deal',
  'telegram_candidates.agent_turn.action.enrich': 'Enrich with AI',
  'telegram_candidates.agent_turn.action.enriching': 'Enriching...',
  'telegram_candidates.agent_turn.confirm.enrich_title': 'Start enrichment?',
  'telegram_candidates.agent_turn.confirm.enrich_description':
    'The AI assistant will analyze the candidate and propose an improved suggestion. Continue?',
  'telegram_candidates.agent_turn.success.enriched': 'Candidate enriched',
  'telegram_candidates.agent_turn.panel.title': 'Agent run',
  'telegram_candidates.agent_turn.error.enrich_failed': 'Could not enrich the candidate',
  'telegram_candidates.agent_turn.error.not_admittable': 'Candidate cannot be enriched',
  'telegram_candidates.agent_turn.error.state_conflict':
    'Candidate version changed, refresh the data',
  'telegram_candidates.agent_turn.status.completed': 'Completed',
  'telegram_candidates.agent_turn.status.failed': 'Failed',
  'telegram_candidates.agent_turn.status.streaming': 'Running',
  'telegram_candidates.agent_turn.status.queued': 'Queued',
  'telegram_candidates.agent_turn.status.cancelled': 'Cancelled',
  'nav.documents': 'Documents',
  'nav.imports': 'Import / Export',
  'nav.templates': 'Templates',
  'nav.workflows': 'Workflows',
  'nav.hot_leads': 'Hot leads',
  'nav.memory': 'Memory',
  'nav.views': 'Views',
  'nav.run_center': 'Run Center',
  'nav.automations': 'Automations',
  'nav.scenario_editor': 'Scenario Editor',
  'nav.prompt_compiler': 'Prompt Compiler',
  'nav.knowledge_base': 'Knowledge Base',
  'nav.files': 'Files',
  'nav.agents': 'Agents',
  'nav.opencode': 'OpenCode',
  'nav.settings': 'Settings',
  'nav.team': 'Team',
  'nav.pro_section': 'Advanced (Pro)',
  'nav.pro_empty': 'Pro mode tools will appear here.',
  'nav.coming_soon': 'Coming soon',

  // Platform admin navigation (visible only to platform admins).
  'admin.nav.dashboard': 'Admin panel',
  'admin.nav.users': 'Users',
  'admin.nav.workspaces': 'Workspaces',
  'admin.nav.plans': 'Plans',
  'admin.nav.llm': 'LLM spend',
  'admin.nav.mail': 'Mail',
  'admin.nav.audit': 'Audit',
  'sidebar.simple_section': 'Basics',
  'sidebar.workspace': 'Workspace',
  'sidebar.brand': 'Govard CRM',
  'topbar.user_menu': 'User menu',
  'topbar.logout': 'Log out',
  'topbar.toggle_context': 'Context panel',
  'topbar.system_agent': 'System panel',
  'topbar.logout_error': 'Failed to exit. Try again.',
  'topbar.workspace_fallback': 'No workspace',
  'topbar.workspace_picker': 'Workspace',
  'topbar.workspace_personal_suffix': 'personal',
  'topbar.workspace_switch_error': 'Failed to switch workspace.',
  'topbar.workspace_create': 'Create workspace',
  'topbar.workspace_create_ok': 'Create',
  'topbar.workspace_create_name': 'Name',
  'topbar.workspace_create_name_placeholder': 'e.g. Aurora Beauty Salon',
  'topbar.workspace_create_error': 'Failed to create workspace.',
  'right_sidebar.title': 'Context panel',
  'right_sidebar.close': 'Close context panel',
  'right_sidebar.description': 'Shell panel for operator context and quick diagnostics.',
  'right_sidebar.system_status': 'System Status',
  'right_sidebar.block_status': 'Status',
  'right_sidebar.status_online': 'Online',
  'right_sidebar.block_scope': 'Scope',
  'right_sidebar.scope_workspace': 'Current workspace',
  'right_sidebar.recent_activity': 'Recent Activity',
  'right_sidebar.activity_visual_contract': 'Visual contract fixed',
  'right_sidebar.activity_now': 'just now',
  'right_sidebar.activity_next_slice': 'Next cut: shell/deals parity',
  'right_sidebar.activity_next': 'next step',
  'settings.title': 'Settings',
  'settings.subtitle': 'Profile, workspace, AI and feature flags for the current workspace.',
  'settings.tabs_aria': 'Settings sections',
  'settings.tabs.profile': 'Profile',
  'settings.tabs.workspace': 'Workspace',
  'settings.tabs.ai': 'AI',
  'settings.tabs.flags': 'Feature flags',
  'settings.tabs.team': 'Team',
  'settings.tabs.security': 'Security',
  'settings.tabs.navigation': 'Menu',
  'settings.navigation.subtitle': 'Order and visibility of sidebar menu items ({count} visible)',
  'settings.navigation.reset': 'Reset to default',
  'settings.navigation.move_group_up': 'Move group "{label}" up',
  'settings.navigation.move_group_down': 'Move group "{label}" down',
  'settings.navigation.move_item_up': 'Move item "{label}" up',
  'settings.navigation.move_item_down': 'Move item "{label}" down',
  'settings.navigation.visibility': 'Show item "{label}"',
  'settings.navigation.visibility_hint': 'Show or hide the item in the sidebar',
  'settings.navigation.hidden_hint':
    'Hidden items are dimmed here and disappear from the sidebar; the switch brings them back.',
  'settings.tabs.data': 'Data',
  'settings.data.title': 'Workspace data',
  'settings.data.description':
    'Export every record of this workspace into a single file, or delete the data entirely.',
  'settings.data.export_title': 'Data export',
  'settings.data.export_description':
    'A JSON file with every entity, or a ZIP archive with one CSV per entity.',
  'settings.data.export_format_label': 'Export format',
  'settings.data.export_format_json': 'JSON',
  'settings.data.export_format_csv': 'CSV (ZIP)',
  'settings.data.export_action': 'Export data',
  'settings.data.export_error': 'Failed to download the data export.',
  'settings.data.danger_title': 'Danger zone',
  'settings.data.danger_description':
    'Deletion erases every record of this workspace — deals, contacts, companies, tasks, notes, meetings, documents, templates and attachments. It cannot be undone.',
  'settings.data.delete_action': 'Delete workspace',
  'settings.data.delete_title': 'Delete this workspace?',
  'settings.data.delete_warning':
    'All workspace data will be permanently deleted and member sessions will be terminated. This action cannot be undone.',
  'settings.data.delete_acknowledge': 'I understand this data will be deleted permanently',
  'settings.data.delete_password_label': 'Owner password',
  'settings.data.delete_confirm': 'Delete permanently',
  'settings.data.error.personal_workspace':
    'A personal workspace cannot be deleted — it is tied to your account.',
  'settings.data.error.last_workspace':
    'This is your only workspace. Create or join another one first.',
  'settings.data.error.invalid_password': 'Incorrect password.',
  'settings.data.error.password_not_set':
    'This account has no password set — set one before deleting.',
  'settings.data.error.generic': 'Failed to delete the workspace.',
  'settings.tabs.telegram': 'Telegram',
  'settings.telegram.title': 'Telegram notifications',
  'settings.telegram.loading': 'Loading Telegram notification settings...',
  'settings.telegram.load_error': 'Could not load Telegram notification settings.',
  'settings.telegram.unavailable': 'Link your private Telegram chat to configure notifications.',
  'settings.telegram.private_only':
    'These notifications are sent only to your linked private bot chat.',
  'settings.telegram.results': 'Action results',
  'settings.telegram.results_description':
    'Receive a generic status after an action you initiated in Telegram is resolved.',
  'settings.telegram.digest': 'Daily summary',
  'settings.telegram.digest_description':
    'Counts of your overdue tasks, tasks due today and pending approvals. No CRM record details.',
  'settings.telegram.language': 'Notification language',
  'settings.telegram.locale_ru': 'Russian',
  'settings.telegram.locale_en': 'English',
  'settings.telegram.timezone': 'Time zone',
  'settings.telegram.time': 'Delivery time',
  'settings.telegram.next_send': 'Next summary: {date}',
  'settings.telegram.save_error': 'Could not save Telegram notification settings.',
  'settings.telegram.rollout_disabled':
    'Daily Telegram summaries are not enabled for this workspace yet.',
  'settings.conversion_digest.title': 'Conversion digest',
  'settings.conversion_digest.description':
    'A daily post: top-5 hot deals (title, amount, stage, reason, next step) and deals untouched for N days. A separate consent — independent of the "Action results" and "Daily summary" subscriptions.',
  'settings.conversion_digest.loading': 'Loading conversion digest settings...',
  'settings.conversion_digest.load_error': 'Could not load conversion digest settings.',
  'settings.conversion_digest.save_error': 'Could not save conversion digest settings.',
  'settings.conversion_digest.enabled_hint':
    'Telegram delivery happens only with this switch on. Without it the digest is saved as a CRM note (while the automation is active).',
  'settings.conversion_digest.hour': 'Delivery hour',
  'settings.conversion_digest.stagnation_days': 'Days without touch',
  'settings.conversion_digest.language': 'Digest language',
  'settings.conversion_digest.telegram_unlinked':
    'Telegram is not linked — the digest will be saved as a CRM note.',
  'settings.loading': 'Loading workspace settings...',
  'settings.profile_stub':
    'Personal profile and team settings will appear in the next steps of Week 5.',
  'settings.workspace_stub': 'This will include workspace settings and team members.',
  'settings.ai_stub':
    'Settings for AI models and limits will be available after chat flow integration.',
  'settings.flags_title': 'Feature Flags',
  'settings.adr_title': 'AI chat: ADR',
  'settings.adr_simple': 'Simple plans',
  'settings.adr_simple_description': 'The foundation for AI chat planning.',
  'settings.adr_planner': 'Planner-first',
  'settings.adr_planner_description': 'Plan reads and individual actions.',
  'settings.adr_compound': 'Compound plans',
  'settings.adr_compound_description': 'Plans with multiple related actions.',
  'settings.adr_batches': 'Batch actions',
  'settings.adr_batches_description': 'Plans for processing multiple records.',
  'settings.adr_approve': 'Approve all',
  'settings.adr_approve_description':
    'One confirmation button for all batch items instead of one by one. Not part of ADR; verified only when off.',
  'settings.adr_requires': 'Requires:',
  'settings.adr_requires_plural': 'Requires:',
  'settings.adr_owner_only':
    'Only the workspace owner or an administrator can change these settings.',
  'settings.adr_master': 'ADR',
  'settings.adr_master_description':
    'New AI chat path with all capabilities. Turning off restores the main behavior.',
  'settings.adr_custom': 'Custom setup',
  'settings.adr_fine_tuning': 'Fine-tuning',
  'settings.adr_hint':
    'Works only with the OpenRouter gateway; tested with Gemini 3.5 flash-lite. Changes apply to new conversations.',
  'settings.adr_error_forbidden': 'You do not have permission to change flags.',
  'settings.adr_error_failed': 'Could not save the flags. Please try again.',
  'settings.flags_description':
    'Enable advanced modes only when you are ready for an advanced interface.',
  'settings.pro_mode_title': 'Pro mode',
  'settings.pro_mode_description': 'Shows the Advanced (Pro) section in the side menu.',
  'settings.enable_pro_mode': 'Enable Pro mode',
  'settings.disable_pro_mode': 'Turn off Pro mode',
  'settings.confirm_title': 'Enable advanced mode?',
  'settings.confirm_body':
    'Scenario Engine, Run Center, Memory Browser will appear. This is for those who want to fine-tune AI behavior. The basic functions work like this.',
  'settings.confirm_submit': 'Enable Pro mode',
  'deals.title': 'Deals',
  'deals.subtitle': 'Kanban by stages. Drag cards or use quick transition to the next stage.',
  'deals.loading': 'Loading deals...',
  'deals.load_error': 'Failed to load deals',
  'deals.retry': 'Retry',
  'deals.empty_stage': 'There are no deals at this stage yet.',
  'deals.move_to_stage': 'Move to {stage}',
  'deals.final_stage': 'Final stage',
  'deals.open_hot_leads': 'Hot leads',
  'deals.summary.total': 'Total deals',
  'deals.summary.active': 'In progress',
  'deals.summary.attention': 'Action needed',
  'deals.next_step': 'Next contact',
  'deals.next_step_missing': 'Not scheduled',
  'deals.stage.New': 'New',
  'deals.stage.Contacted': 'Contact established',
  'deals.stage.Negotiation': 'Negotiation',
  'deals.stage.Won': 'Won',
  'deals.stage.Lost': 'Lost',
  'contacts.title': 'Contacts',
  'contacts.subtitle':
    'Search through the customer database, quick viewing and protection from duplicates when creating.',
  'contacts.list_title': 'Contact database',
  'contacts.list_description': 'Search by name, email or phone number and open the contact card.',
  'contacts.search_label': 'Search contacts',
  'contacts.search_submit': 'Find',
  'contacts.loading': 'Loading contacts...',
  'contacts.load_error': 'Could not load contacts',
  'contacts.empty': 'No contacts found',
  'contacts.no_channel': 'Contacts not specified',
  'contacts.create_title': 'New contact',
  'contacts.create_description':
    'Add the client manually. If the email is already in the database, we will show the existing card.',
  'contacts.create_submit': 'Add a contact',
  'contacts.form.first_name': 'Name',
  'contacts.form.last_name': 'Last name',
  'contacts.form.email': 'Email',
  'contacts.form.phone': 'Phone',
  'contacts.duplicate_banner': 'This email already exists',
  'contacts.open_contact': 'Open contact',
  'contacts.summary.total': 'Total contacts',
  'contacts.summary.with_deals': 'With deals',
  'contacts.summary.with_email': 'With email',
  'contacts.back_to_contacts': 'To contacts',
  'contacts.detail.deals': 'Deals',
  'contacts.detail.notes': 'Notes',
  'contacts.detail.activity': 'Activity',
  'contacts.detail.role': 'Role',
  'contacts.detail.company': 'Company',
  'contacts.mvp.breadcrumbs': 'Contacts / Contact Profile',
  'contacts.mvp.placeholder.activity': 'The activity timeline will appear here',
  'contacts.mvp.placeholder.deals': 'The deals table will appear here',
  'contacts.mvp.placeholder.notes': 'The notes editor will appear here',
  'contacts.detail.interactions': 'Recent interactions',
  'contacts.detail.no_interactions': 'There are no contact events yet.',
  'contacts.detail.source': 'Source',
  'contacts.detail.source_missing': 'Not specified',
  'templates.title': 'Templates',
  'templates.subtitle': 'Ready-to-use templates for emails, SMS, and in-app messages.',
  'templates.subtitle_unit': 'templates',
  'templates.list_title': 'Template catalog',
  'templates.editor_title': 'Template editor',
  'templates.editor_empty': 'Select a template in the table to change the text and variables.',
  'templates.new_template': '6 templates from seed are available for editing.',
  'templates.new': 'New template',
  'templates.name': 'Name',
  'templates.channel_label': 'Channel',
  'templates.search_label': 'Search templates',
  'templates.search_placeholder': 'Search by title, topic or text',
  'templates.refresh': 'Refresh templates',
  'templates.reset_filters': 'Reset',
  'templates.new_body': 'New template text',
  'templates.create_submit': 'Create a template',
  'templates.create_description': 'Create a new template for email, SMS or in-app messages.',
  'templates.loading': 'Loading templates...',
  'templates.load_error': 'Failed to load templates',
  'templates.load_error_description': 'Check your connection and try again.',
  'templates.retry': 'Retry',
  'templates.empty': 'There are no templates yet. Create your first quick message template.',
  'templates.empty_filtered': 'There are no templates for current filters.',
  'templates.save': 'Save',
  'templates.open': 'Open',
  'templates.subject': 'Subject',
  'templates.body': 'Text',
  'templates.no_preview': 'No subject or text',
  'templates.no_variables': 'No variables',
  'templates.variables': 'Variables',
  'templates.usage_count': 'Uses',
  'templates.channel_filter_label': 'Channel:',
  'templates.name_placeholder': 'Template name',
  'templates.channel.email': 'Email',
  'templates.channel.sms': 'SMS',
  'templates.channel.in_app': 'In-app',
  'templates.filter.all': 'All',
  'templates.summary.total': 'Total templates',
  'templates.summary.email': 'Email',
  'templates.summary.sms': 'SMS',
  'templates.summary.in_app': 'In-app',
  'templates.table.template': 'Template',
  'templates.table.action': 'Action',
  'templates.editor.usage_count': 'Uses {count}',
  'templates.editor.variables_count_one': '{count} variable',
  'templates.editor.variables_count_few': '{count} variables',
  'templates.editor.variables_count_many': '{count} variables',
  'hot_leads.title': 'Hot leads',
  'hot_leads.subtitle': 'Deals that need attention right now.',
  'hot_leads.table_title': 'Priority deals',
  'hot_leads.table_description': 'Prioritized using activity, upcoming actions, and deal value.',
  'hot_leads.table_header.deal': 'Deal',
  'hot_leads.table_header.contact': 'Contact',
  'hot_leads.table_header.stage': 'Stage',
  'hot_leads.table_header.reason': 'Reason',
  'hot_leads.table_header.action': 'Action',
  'hot_leads.loading': 'Calculating hot leads...',
  'hot_leads.no_contact': 'No contact',
  'hot_leads.filter.all': 'All',
  'hot_leads.filter.stale': 'no activity',
  'hot_leads.filter.due': 'next steps',
  'hot_leads.filter.high_value': 'high amount',
  'hot_leads.reason.stale': 'no activity 4 days',
  'hot_leads.reason.due': 'action soon',
  'hot_leads.reason.high_value': 'high amount',
  'hot_leads.filter.overdue_next_activity': 'overdue activity',
  'hot_leads.filter.missing_next_activity': 'no next activity',
  'hot_leads.filter.stale_activity': 'no recent activity',
  'hot_leads.filter.overdue_task': 'overdue task',
  'hot_leads.open_ai': 'Open in AI chat',
  'hot_leads.recovery_title': 'Hot leads',
  'hot_leads.visible_count': '{visible} of {total} deals need attention',
  'hot_leads.table_header.amount': 'Amount',
  'hot_leads.table_header.score': 'Priority',
  'hot_leads.table_header.recommendation': 'Next step',
  'hot_leads.reason.overdue_next_activity': 'next activity overdue',
  'hot_leads.reason.missing_next_activity': 'no next activity',
  'hot_leads.reason.stale_activity': 'no recent activity',
  'hot_leads.reason.overdue_task': 'overdue task',
  'hot_leads.recommendation.email': 'Draft an email',
  'hot_leads.recommendation.call': 'Contact the client',
  'hot_leads.open_recovery': 'Review',
  'hot_leads.refresh': 'Refresh queue',
  'hot_leads.search_label': 'Search recovery queue',
  'hot_leads.search_placeholder': 'Search by deal or contact',
  'hot_leads.reason_filter': 'Reason filter',
  'hot_leads.stage_filter': 'Stage filter',
  'hot_leads.all_stages': 'All stages',
  'hot_leads.empty': 'No deals need recovery for the selected filters.',
  'hot_leads.load_error': 'Could not load hot leads',
  'hot_leads.table_header.win_probability': 'Probability',

  // Win probability (conversion package BP-3): heuristic on-read scoring.
  'win_probability.title': 'Win probability',
  'win_probability.factors': 'Top factors',
  'win_probability.factor.recent_engagement': {
    one: '{count} active touch in the last {days} days',
    other: '{count} active touches in the last {days} days',
  },
  'win_probability.factor.amount_above_median':
    'Amount at or above the workspace median ({ratio}×)',
  'win_probability.factor.amount_below_median': 'Amount well below the workspace median ({ratio}×)',
  'win_probability.factor.no_risk_signals': 'No explicit risk signals',

  // Next best action (NBA shock package): one recommendation per deal.
  'features.deals.nextBestAction.title.schedule_activity': 'Schedule the next step',
  'features.deals.nextBestAction.title.complete_overdue_tasks': 'Close overdue tasks',
  'features.deals.nextBestAction.title.log_touch': 'Log a client touch',
  'features.deals.nextBestAction.title.fill_qualification': 'Complete the qualification',
  'features.deals.nextBestAction.title.advance_stage': 'Advance the deal stage',
  'features.deals.nextBestAction.reason.next_activity_missing': 'No next step is scheduled',
  'features.deals.nextBestAction.reason.next_activity_overdue':
    'The next step is {days} days overdue',
  'features.deals.nextBestAction.reason.overdue_tasks': 'Overdue tasks: {count}',
  'features.deals.nextBestAction.reason.stale_activity': 'No client touches for {days} days',
  'features.deals.nextBestAction.reason.qualification_gaps':
    '{gaps} of {total} qualification items are not confirmed',
  'features.deals.nextBestAction.reason.stage_age_over_norm':
    'On the "{stage}" stage for {days} days (norm {norm} days)',
  // Attention queue (batch 4): pipeline-wide "money at risk" digest. The reason
  // chips reuse the engine codes, but the queue carries no params, so these are
  // the short param-free labels instead of the `reason.*` sentences above.
  'features.deals.nextBestAction.queue.title': 'Money at risk',
  'features.deals.nextBestAction.queue.open': 'All deals',
  'features.deals.nextBestAction.queue.score': 'Win chance',
  'features.deals.nextBestAction.queue.amount_of': 'of {amount}',
  'features.deals.nextBestAction.queue.empty': 'No money at risk in the open pipeline',
  'features.deals.nextBestAction.queue.empty_hint':
    'Every open deal has a next step and recent client touches.',
  'features.deals.nextBestAction.queue.error': 'Could not load the attention queue',
  'features.deals.nextBestAction.queue.retry': 'Retry',
  'features.deals.nextBestAction.queue.row_aria': 'Deal {title}: {risk} at risk',
  'features.deals.nextBestAction.queue.reason.next_activity_missing': 'No next step',
  'features.deals.nextBestAction.queue.reason.next_activity_overdue': 'Next step is overdue',
  'features.deals.nextBestAction.queue.reason.overdue_tasks': 'Overdue tasks',
  'features.deals.nextBestAction.queue.reason.stale_activity': 'No recent touches',
  'features.deals.nextBestAction.queue.reason.qualification_gaps': 'Qualification gaps',
  'features.deals.nextBestAction.queue.reason.stage_age_over_norm': 'Stuck in stage',
  'features.deals.nextBestAction.confidence.label': 'Confidence',
  'features.deals.nextBestAction.impact.label': 'Projected impact',
  // "pp" is percentage points; the abbreviation is invariant across plurals.
  'features.deals.nextBestAction.impact.points': {
    one: '+{count} pp',
    other: '+{count} pp',
  },
  'features.deals.nextBestAction.execute': 'Execute',
  'features.deals.nextBestAction.empty': 'No recommendations right now',
  'features.deals.nextBestAction.error.load': 'Could not load the recommendation',
  'features.deals.nextBestAction.error.execute': 'Could not execute the action',
  // Next-step card and what-if simulator (batch 2).
  'features.deals.nextBestAction.card.title': 'Next step',
  'features.deals.nextBestAction.loading': 'Calculating the next step…',
  'features.deals.nextBestAction.score.current': 'Now',
  'features.deals.nextBestAction.score.projected': 'After the action',
  'features.deals.nextBestAction.meta.overdueTasks': 'Overdue tasks: {count}',
  'features.deals.nextBestAction.meta.targetStage': 'Target stage: {stage}',
  'features.deals.nextBestAction.preview.title': 'What will happen',
  'features.deals.nextBestAction.preview.effect.schedule_activity':
    'Create a task in the coming days and make it the next step of the deal.',
  'features.deals.nextBestAction.preview.effect.complete_overdue_tasks':
    'Close every overdue task of the deal in one go.',
  'features.deals.nextBestAction.preview.effect.log_touch':
    'Record a client touch and refresh the last activity date.',
  'features.deals.nextBestAction.preview.effect.fill_qualification':
    'Open the card to confirm the qualification items.',
  'features.deals.nextBestAction.preview.effect.advance_stage': 'Move the deal to the next stage.',
  'features.deals.nextBestAction.result.done': 'Done. Probability: {before}% → {after}%',
  'features.deals.nextBestAction.simulator.title': 'What if',
  'features.deals.nextBestAction.simulator.hint':
    'A forecast only: nothing changes in the deal until the step is executed.',
  'features.deals.nextBestAction.simulator.type': 'Action',
  'features.deals.nextBestAction.simulator.error': 'Could not calculate the projection',
  'features.deals.nextBestAction.empty.hint': 'Every signal is healthy — the deal can move on.',
  'features.deals.nextBestAction.navigate.stage': 'Go to the stage control',
  'features.deals.nextBestAction.navigate.qualification': 'Open qualification',
  'features.deals.nextBestAction.task.schedule': 'Next step for the deal',
  'features.deals.nextBestAction.touch.subject': 'Touch logged from the deal card',
  'approvals.approve': 'Approve',
  'approvals.reject': 'Reject',
  'approvals.pending': 'Awaiting approval',
  'approvals.approved': 'Approved',
  'approvals.rejected': 'Rejected',
  'approvals.expired': 'Expired',
  'approvals.cancelled': 'Cancelled',
  'approvals.expires_at': 'Expires:',
  'approvals.execution_result': 'Execution result',
  'approvals.execution_failed': 'Action failed',
  'approvals.execution_failed_details':
    'The approval was saved, but the requested action was not completed.',
  'approvals.execution_executing': 'Executing',
  'approvals.execution_succeeded': 'Succeeded',
  'approvals.execution_pending_verification': 'Result pending verification',
  'approvals.consistency.title': 'Review the data: the message and the action disagree',
  'approvals.consistency.missing':
    '"{field}": the message says "{expected}", but the action leaves it empty',
  'approvals.consistency.mismatch':
    '"{field}": the message says "{expected}", the action has "{actual}"',
  'approvals.execution_stale': 'Stage already changed',
  'approvals.execution_stale_details':
    'The deal stage changed after this preview. Create a new approval.',
  'approvals.execution_stale_write': 'Record already changed',
  'approvals.execution_stale_write_details':
    'The record changed after the approval preview. Prepare the action again and retry.',
  'approvals.detail.memory_key': 'Key',
  'approvals.detail.memory_level': 'Memory level',
  'approvals.detail.memory_value': 'Fact',
  'approvals.detail.memory_importance': 'Importance',
  'approvals.detail.memory_embedding': 'Semantic search',
  'approvals.detail.memory_embedding_requested':
    'The text will be sent to an AI provider to create an embedding. Its result is verified separately.',
  'approvals.summary.generic': 'Confirm the requested action',
  'approvals.summary.create_deal': 'Create a deal',
  'approvals.summary.update_deal': 'Update the deal',
  'approvals.summary.delete_deal': 'Delete the deal',
  'approvals.summary.add_deal_note': 'Add a note to the deal',
  'approvals.summary.update_deal_stage': 'Change the deal stage',
  'approvals.summary.create_deal_tasks': 'Create deal tasks',
  'approvals.summary.update_deal_qualification': 'Update the deal qualification',
  'approvals.summary.send_email': 'Send the prepared email',
  'approvals.summary.enrich_contact': 'Update the contact with enrichment data',
  'approvals.summary.run_scenario': 'Run the scenario',
  'approvals.summary.write_memory': 'Save information to AI memory',
  'approvals.summary.update_memory': 'Update information in AI memory',
  'approvals.summary.delete_memory': 'Delete information from AI memory',
  'approvals.summary.execute_import': 'Run the reviewed import',
  'approvals.summary.document_to_note': 'Create a note from a document',
  'approvals.summary.conversation_to_note': 'Save the conversation as a note',
  'approvals.summary.refresh_entity_context': 'Refresh the record context',
  'approvals.summary.generate_dashboard_widget': 'Create a dashboard widget',
  'approvals.summary.create_text_attachment': 'Create a text attachment',
  'approvals.summary.update_text_attachment': 'Update a text attachment',
  'approvals.summary.create_task': 'Create a task',
  'approvals.summary.update_task': 'Update the task',
  'approvals.summary.delete_task': 'Delete the task',
  'approvals.summary.set_task_status': 'Change the task status',
  'approvals.summary.assign_task': 'Assign the task',
  'approvals.summary.link_task': 'Link the task to a record',
  'approvals.summary.unlink_task': 'Remove the task link',
  'approvals.summary.set_task_due_date': 'Change the task due date',
  'approvals.summary.create_note': 'Create a note',
  'approvals.summary.update_note': 'Update the note',
  'approvals.summary.delete_note': 'Delete the note',
  'approvals.summary.link_note': 'Link the note to a record',
  'approvals.summary.unlink_note': 'Remove the note link',
  'approvals.summary.create_contact': 'Create a contact',
  'approvals.summary.update_contact': 'Update the contact',
  'approvals.summary.delete_contact': 'Delete the contact',
  'approvals.summary.set_contact_tags': 'Change the contact tags',
  'approvals.summary.set_contact_owner': 'Change the contact owner',
  'approvals.summary.link_contact_company': 'Link the contact to a company',
  'approvals.summary.unlink_contact_company': 'Unlink the contact from its company',
  'approvals.summary.create_contact_interaction': 'Log a contact interaction',
  'approvals.summary.update_contact_interaction': 'Update the contact interaction',
  'approvals.summary.delete_contact_interaction': 'Delete the contact interaction',
  'approvals.summary.create_company': 'Create a company',
  'approvals.summary.update_company': 'Update the company',
  'approvals.summary.delete_company': 'Delete the company',
  'approvals.summary.create_project': 'Create a project',
  'approvals.summary.add_project_member': 'Add a project member',
  'approvals.summary.remove_project_member': 'Remove a project member',
  'approvals.summary.update_project': 'Update the project',
  'approvals.summary.delete_project': 'Delete the project',
  'approvals.summary.set_company_tags': 'Change the company tags',
  'approvals.summary.set_company_owner': 'Change the company owner',
  'approvals.summary.link_company_relation': 'Link a record to the company',
  'approvals.summary.unlink_company_relation': 'Unlink a record from the company',
  'approvals.detail.name': 'Name',
  'approvals.detail.first_name': 'First name',
  'approvals.detail.last_name': 'Last name',
  'approvals.detail.phone': 'Phone',
  'approvals.detail.email': 'Email',
  'approvals.detail.role': 'Role',
  'approvals.detail.company': 'Company',
  'approvals.detail.member': 'Member',
  'approvals.detail.interaction_type': 'Interaction type',
  'approvals.impact.label': 'Affected records',
  'approvals.impact.contacts': 'contacts: {count}',
  'approvals.impact.deals': 'deals: {count}',
  'approvals.impact.tasks': 'tasks: {count}',
  'approvals.impact.documents': 'documents: {count}',
  'approvals.impact.interactions': 'interactions: {count}',
  'approvals.impact.notes': 'note records: {count}',
  'approvals.impact.calendarEvents': 'meeting records: {count}',
  'approvals.impact.calendarParticipants': 'meeting participant links: {count}',
  'approvals.impact.noteLinks': 'note links: {count}',
  'approvals.impact.attachments': 'attachment records: {count}',
  'approvals.impact.projectMembers': 'project members: {count}',
  'approvals.detail.title': 'Title',
  'approvals.detail.deal': 'Deal',
  'approvals.scenario_step.follow_up.action': 'Send follow-up email',
  'approvals.scenario_step.follow_up.recipient': 'Recipient',
  'approvals.scenario_step.follow_up.subject': 'Subject',
  'approvals.scenario_step.workflow.action': 'Approve workflow step',
  'approvals.scenario_step.workflow.step': 'Workflow step',
  'approvals.scenario_step.workflow.requires': 'Requires confirmation before execution',
  'approvals.scenario_step.workflow.requires_destructive': 'Destructive action',
  'approvals.scenario_step.workflow_email.action': 'Approve email sending',
  'approvals.scenario_step.workflow_email.recipient': 'Recipient',
  'approvals.scenario_step.workflow_email.subject': 'Subject',
  'approvals.scenario_step.workflow_email.body': 'Email body',
  'approvals.detail.stage': 'New stage',
  'approvals.detail.from_stage': 'From',
  'approvals.detail.to_stage': 'To',
  'approvals.detail.stage_transition': 'From: {fromStage} → To: {toStage}',
  'approvals.detail.subject': 'Subject',
  'approvals.detail.recipient': 'Recipient',
  'approvals.detail.memory': 'Memory key',
  'approvals.detail.scenario': 'Scenario',
  'approvals.detail.contact': 'Contact',
  'approvals.detail.actions': 'Actions: {count}',
  'approvals.detail.status': 'Status',
  'approvals.detail.priority': 'Priority',
  'approvals.detail.due_at': 'Due date',
  'approvals.detail.start_date': 'Start date',
  'approvals.detail.due_date': 'Due date',
  'approvals.detail.assignee': 'Assignee',
  'approvals.detail.owner': 'Owner',
  'approvals.detail.project': 'Project',
  'approvals.detail.task': 'Task',
  'approvals.detail.document': 'Document',
  'approvals.detail.link': 'Link',
  'approvals.detail.file_name': 'File',
  'approvals.detail.entity_type': 'Entity type',
  'approvals.detail.rows': 'Rows',
  'approvals.detail.review': 'Review the requested action before confirming.',
  'approvals.detail.from': 'From',
  'approvals.detail.to': 'To',
  'approvals.detail.reason': 'Reason',
  'approvals.detail.description': 'Description',
  'approvals.detail.source': 'Source',
  'approvals.detail.tags': 'Tags',
  'approvals.detail.name_unavailable': 'Name unavailable',
  'approvals.detail.field_changed': 'Changed field',
  'approvals.detail.domain': 'Domain',
  'approvals.detail.industry': 'Industry',
  'approvals.detail.website': 'Website',
  'approvals.bulk.summary.create_deals': 'Create deals in bulk',
  'approvals.bulk.summary.update_deals': 'Update deals in bulk',
  'approvals.bulk.summary.delete_deals': 'Delete deals in bulk',
  'approvals.bulk.summary.set_deal_stage': 'Change deal stages in bulk',
  'approvals.bulk.summary.set_deal_owner': 'Change deal owners in bulk',
  'approvals.bulk.summary.set_deal_tags': 'Change deal tags in bulk',
  'approvals.bulk.summary.create_tasks': 'Create tasks in bulk',
  'approvals.bulk.summary.update_tasks': 'Update tasks in bulk',
  'approvals.bulk.summary.delete_tasks': 'Delete tasks in bulk',
  'approvals.bulk.summary.set_task_status': 'Change task statuses in bulk',
  'approvals.bulk.summary.set_task_assignee': 'Change task assignees in bulk',
  'approvals.bulk.summary.set_task_due_date': 'Change task due dates in bulk',
  'approvals.bulk.summary.create_notes': 'Create notes in bulk',
  'approvals.bulk.summary.update_notes': 'Update notes in bulk',
  'approvals.bulk.summary.delete_notes': 'Delete notes in bulk',
  'approvals.bulk.summary.link_notes': 'Link notes to records in bulk',
  'approvals.bulk.summary.unlink_notes': 'Remove note links in bulk',
  'approvals.bulk.summary.create_contacts': 'Create contacts in bulk',
  'approvals.bulk.summary.update_contacts': 'Update contacts in bulk',
  'approvals.bulk.summary.delete_contacts': 'Delete contacts in bulk',
  'approvals.bulk.summary.set_contact_tags': 'Change contact tags in bulk',
  'approvals.bulk.summary.set_contact_owner': 'Change contact owners in bulk',
  'approvals.bulk.summary.link_contact_company': 'Link contacts to a company in bulk',
  'approvals.bulk.summary.unlink_contact_company': 'Unlink contacts from a company in bulk',
  'approvals.bulk.summary.create_companies': 'Create companies in bulk',
  'approvals.bulk.summary.update_companies': 'Update companies in bulk',
  'approvals.bulk.summary.delete_companies': 'Delete companies in bulk',
  'approvals.bulk.summary.set_company_tags': 'Change company tags in bulk',
  'approvals.bulk.summary.set_company_owner': 'Change company owners in bulk',
  'approvals.bulk.summary.link_companies': 'Link records to companies in bulk',
  'approvals.bulk.summary.unlink_companies': 'Unlink records from companies in bulk',
  'approvals.bulk.review_count': 'Review {count} records before confirming.',
  'approvals.bulk.field.amount': 'Amount',
  'approvals.bulk.assignee.change': 'Set a new assignee',
  'approvals.bulk.assignee.remove': 'Remove the assignee',
  'approvals.bulk.count': '{count} records selected',
  'approvals.bulk.partial_semantics':
    'Each record is saved independently; some may succeed while others fail.',
  'approvals.bulk.excluded': '{count} records excluded by safety checks',
  'approvals.bulk.relation_type': 'Linked record type: {relationType}',
  'approvals.bulk.relation.deal': 'deal',
  'approvals.bulk.relation.company': 'company',
  'approvals.bulk.relation.contact': 'contact',
  'approvals.bulk.relation.task': 'task',
  'approvals.bulk.relation.calendar_event': 'meeting',
  'approvals.bulk.relation.document': 'document',
  'approvals.bulk.relation.template': 'template',
  'approvals.bulk.relation.mixed': 'mixed record types',
  'approvals.bulk.item': 'Record {number}',
  'approvals.bulk.sample_capped': 'Showing up to {count} records; and {remaining} more.',
  'approvals.bulk.result':
    'Succeeded: {succeeded} · Failed: {failed} · Changed meanwhile: {stale} · Skipped: {skipped} · In progress: {unfinished}',
  'approvals.bulk.delete_warning':
    'This will delete {count} records. Confirm the exact count before continuing.',
  'approvals.bulk.confirm_delete': 'Delete {count}',
  'approvals.bulk.status.partial': 'Partially completed',
  'approvals.bulk.status.retry': 'Prepare again',
  'approvals.bulk.retry_details':
    'The durable attempt ended safely. Review a fresh preview before trying again.',
  'approvals.bulk.item_status.pending': 'Pending',
  'approvals.bulk.item_status.executing': 'In progress',
  'approvals.bulk.item_status.succeeded': 'Succeeded',
  'approvals.bulk.item_status.failed': 'Failed',
  'approvals.bulk.item_status.stale': 'Changed',
  'approvals.bulk.item_status.skipped': 'Skipped',
  'deal_card.loading': 'Loading deal...',
  'deal_card.retry': 'Retry',
  'deal_card.error_title': 'Failed to load deal',
  'deal_card.error_retry': 'Try refreshing the page.',
  'deal_card.back_to_deals': 'Back to deals',
  'deal_card.sections_label': 'Deal sections',
  'deal_card.tabs.details': 'Details',
  'deal_card.tabs.activity': 'Activity',
  'deal_card.tabs.notes': 'Notes',
  'deal_card.tabs.tasks': 'Tasks',
  'deal_card.tabs.chat': 'Chat',
  'deal_card.summary.amount': 'Amount',
  'deal_card.summary.contact': 'Contact',
  'deal_card.summary.source': 'Source',
  'deal_card.summary.activity_count': 'Activities',
  'deal_card.summary.next_step': 'Next contact',
  'deal_card.summary.owner': 'Owner',
  'deal_card.activity_count': {
    one: '{count} activity',
    other: '{count} activities',
  },
  'deal_card.details_title': 'Deal details',
  'deal_card.details.contact': 'Contact',
  'deal_card.details.contact_missing': 'Contact not specified',
  'deal_card.details.source': 'Source:',
  'deal_card.details.source_missing': 'Not specified',
  'deal_card.details.next_activity': 'Next contact',
  'deal_card.details.next_activity_missing': 'Not scheduled',
  'deal_card.form.title': 'Deal name',
  'deal_card.form.amount': 'Amount',
  'deal_card.form.source': 'Source',
  'deal_card.form.next_activity': 'Next contact',
  'deal_card.details_save': 'Save details',
  'deal_card.activity_title': 'Latest activity',
  'deal_card.notes_title': 'Notes',
  'deal_card.notes_placeholder': 'We will connect the note editor in the next step.',
  'deal_card.notes_empty': 'No notes yet.',
  'deal_card.note_new_label': 'New note',
  'deal_card.note_placeholder': 'What is important to remember before your next contact?',
  'deal_card.note_save': 'Save note',
  'deal_card.note_subject_fallback': 'Note',
  'deal_card.quick_add_note': 'Add a note',
  'deal_card.chat_title': 'Chat',
  'deal_card.chat_desktop_note': 'AI chat opens in the slide-over panel.',
  'deal_card.chat_mobile_title': 'AI Chat',
  'deal_card.open_chat': 'Open AI chat',
  'chat.conversations': 'Conversations',
  'chat.new_conversation': 'New conversation',
  'chat.settings': 'Settings',
  'chat.open_chat': 'Open AI chat',
  'chat.drawer_title': 'AI Chat',
  'chat.active_model.neuraldeep': 'NeuralDeep',
  'chat.active_model.openrouter': 'OpenRouter · {model}',
  'ai_chat.route.used': 'Used: {provider} · {model} · trace {trace}',
  'ai_chat.route.requested': 'Requested: {provider} · {model}',
  'ai_chat.route.provider.opencode': 'OpenCode Zen',
  'ai_chat.route.provider.govard': 'Govard',
  'ai_chat.route.provider.openrouter': 'OpenRouter',
  'ai_chat.route.provider.neuraldeep': 'NeuralDeep',
  'ai_chat.route.provider.anthropic': 'Anthropic',
  'ai_chat.route.provider.stub': 'Test gateway',
  'approvals.undo': 'Undo',
  'approvals.detail.undo_context': 'Context',
  'approvals.undo_creation_context': 'Undo of task creation',
  'approvals.undo_created_task_label': 'Undo task creation',
  'approvals.undo_state.unavailable': 'The task creation receipt is unavailable in this chat.',
  'approvals.undo_state.pending': 'Undo has already been requested and is awaiting confirmation.',
  'approvals.undo_state.executing': 'Undo has already been confirmed and is being executed.',
  'approvals.undo_state.succeeded': 'The task has already been deleted.',
  'approvals.undo_state.rejected':
    'Undo was rejected. If needed, delete the task manually on the Tasks page.',
  'approvals.undo_state.expired':
    'The undo confirmation expired. Delete the task manually on the Tasks page.',
  'approvals.undo_state.failed':
    'Undo failed; the task may have changed. Check it on the Tasks page.',
  'approvals.undo_state.cancelled':
    'Undo was cancelled. If needed, delete the task manually on the Tasks page.',
  'approvals.undo_state.completed': 'The task is already completed; its creation was not undone.',
  'approvals.undo_state.stale':
    'The task changed after creation; its creation was not undone. Check it on the Tasks page.',
  'approvals.undo_create_task_prompt':
    'Prepare deletion of task “{title}” (taskId: {taskId}, expectedUpdatedAt: {expectedUpdatedAt}). Show a separate deletion confirmation first.',
  'deal_card.chat_mobile_description':
    'The chat is open in mobile focus mode for the current deal.',
  'deal_card.owner_title': 'Owner',
  'deal_card.owner_label': 'Owner',
  'deal_card.owner_missing': 'Not assigned',
  'deal_card.close_chat': 'Close',
  'dashboard.onboarding.title': 'CRM setup',
  'dashboard.onboarding.welcome_title': 'Welcome to GovardOS',
  'dashboard.onboarding.welcome_hint':
    "Let's get your CRM configured and your first pipeline flowing. Finish these steps to unlock full potential.",
  'dashboard.onboarding.progress_label': 'Progress',
  'dashboard.onboarding.first_deal': 'First deal',
  'dashboard.onboarding.client_contacted': 'Customer contact',
  'dashboard.onboarding.deal_won': 'Successful deal',
  'dashboard.onboarding.dismiss': 'Hide',
  'dashboard.loading': 'Updating key metrics...',
  'dashboard.kpi.projects': 'Projects',
  'dashboard.kpi.projects_hint': 'Portfolio entities',
  'dashboard.kpi.active': 'Active',
  'dashboard.kpi.active_hint': 'Open pipeline deals',
  'dashboard.kpi.tasks_done': 'Tasks done',
  'dashboard.kpi.tasks_done_hint': 'Scheduled vs total',
  'dashboard.kpi.sessions': 'Sessions',
  'dashboard.kpi.sessions_hint': 'Running scenario runs',
  'dashboard.kpi.success_rate': 'Success rate',
  'dashboard.kpi.success_rate_hint': 'Completed scenario runs',
  'dashboard.kpi.total_cost': 'Total cost',
  'dashboard.kpi.total_cost_hint': 'Template usage + ops load',
  'dashboard.kpi.vs_last_period': 'vs last period',
  'dashboard.kpi.section_label': 'Key metrics',
  'dashboard.kpi.this_week': 'this week',
  'dashboard.kpi.created_recently': 'new this period',
  'dashboard.status.active': 'Active',
  'dashboard.status.running': 'Running',
  'dashboard.status.completed': 'Completed',
  'dashboard.status.done': 'Done',
  'dashboard.status.paused': 'Paused',
  'dashboard.status.blocked': 'Blocked',
  'dashboard.status.failed': 'Failed',
  'dashboard.status.cancelled': 'Cancelled',
  'dashboard.status.offline': 'Offline',
  'dashboard.status.backlog': 'Backlog',
  'dashboard.status.todo': 'To do',
  'dashboard.status.pending': 'Pending',
  'dashboard.status.in_progress': 'In progress',
  'dashboard.workforce.active': '{count} active',
  'chat.title': 'AI Chat',
  'chat.ready': 'Ready',
  'chat.context_hint':
    'The assistant sees the current deal, contact, activity and can prepare the next step.',
  'chat.suggestions_title': 'Quick actions',
  'chat.suggestion_next_step': 'Suggest next step',
  'chat.suggestion_next_step_prompt':
    'Analyze the current deal {dealId} and suggest the single best next step with a brief rationale.',
  'chat.suggestion_risks': 'Analyze deal risk',
  'chat.suggestion_risks_prompt':
    "Analyze the risk of loss for the current trade {dealId}. Call analyze_deal_risk, show the signals found and the recommended follow-up. Don't create a task, change the stage, or send an email.",
  'chat.suggestion_action_plan': 'Make an action plan',
  'chat.suggestion_action_plan_prompt':
    'Create an action plan for the current deal {dealId}: propose 1–5 specific actions with a priority, due date, and brief rationale. Show the plan only; do not create tasks yet.',
  'chat.suggestion_cockpit': 'Show Deal Cockpit',
  'chat.suggestion_cockpit_prompt':
    'Show the status of the current deal {dealId} in the form of Deal Cockpit. Call get_deal_cockpit. This is a read-only review: do not change deals, tasks and letters.',
  'chat.placeholder': 'Ask the assistant about the deal...',
  'chat.send': 'Send',
  'chat.deal_summary.amount': 'Amount',
  'chat.deal_summary.source': 'Source',
  'chat.deal_summary.source_missing': 'Not specified',
  'chat.deal_summary.contact': 'Contact',
  'chat.deal_summary.contact_missing': 'Contact not specified',
  'chat.deal_summary.next_activity': 'Next activity',
  'chat.deal_summary.next_activity_missing': 'Not planned',
  'chat.deal_summary.last_activity': 'Last activity',
  'chat.deal_summary.last_activity_missing': 'No data',
  'chat.deal_summary.activities': 'Latest events',
  'chat.deal_summary.activities_empty': 'There are no events yet',
  'chat.deal_cockpit.health_label': 'Deal health',
  'chat.deal_cockpit.health.low': 'Stable',
  'chat.deal_cockpit.health.medium': 'Needs attention',
  'chat.deal_cockpit.health.high': 'High risk',
  'chat.deal_cockpit.signals_found': 'Risk signals: {count}',
  'chat.deal_cockpit.amount': 'Amount',
  'chat.deal_cockpit.open_tasks': 'Open tasks',
  'chat.deal_cockpit.overdue': 'Overdue',
  'chat.deal_cockpit.contact': 'Contact',
  'chat.deal_cockpit.contact_missing': 'Contact not specified',
  'chat.deal_cockpit.next_activity': 'Next activity',
  'chat.deal_cockpit.last_activity': 'Last activity',
  'chat.deal_cockpit.not_scheduled': 'Not planned',
  'chat.deal_cockpit.no_activity': 'No data',
  'chat.deal_cockpit.risk_signals': 'Risk signals',
  'chat.deal_cockpit.qualification_title': 'Qualification',
  'chat.deal_cockpit.qualification_field.need': 'Need',
  'chat.deal_cockpit.qualification_field.budget': 'Budget',
  'chat.deal_cockpit.qualification_field.decisionMaker': 'Decision maker',
  'chat.deal_cockpit.qualification_field.decisionDeadline': 'Decision deadline',
  'chat.deal_cockpit.qualification_field.selectionCriteria': 'Selection criteria',
  'chat.deal_cockpit.next_best_action': 'Best Next Step',
  'chat.deal_cockpit.tasks': 'Tasks',
  'chat.deal_cockpit.tasks_empty': 'There are no open tasks',
  'chat.deal_cockpit.read_only': 'This is just a review. CRM data has not been changed.',
  'chat.deal_risk.badge': 'Deal risk',
  'chat.deal_risk.signals': 'Risk signals',
  'chat.deal_risk.signal_count': {
    one: '{count} risk signal',
    other: '{count} risk signals',
  },
  'chat.deal_risk.signals_empty': 'No obvious risk signals were found.',
  'chat.deal_risk.recommendation': 'Recommended Next Step',
  'chat.deal_risk.channel.email': 'Follow-up by email',
  'chat.deal_risk.channel.call': 'Contact the client',
  'chat.deal_risk.channel.none': 'No action required',
  'chat.deal_risk.read_only':
    'This is just an analysis. The deal, tasks and letter were not changed.',
  'chat.deal_risk.prepare_follow_up': 'Prepare a follow-up',
  'chat.deal_risk.level.low': 'Low risk',
  'chat.deal_risk.level.medium': 'Medium risk',
  'chat.deal_risk.level.high': 'High risk',
  'chat.deal_risk.carousel_title': 'Deal Risk Analysis',
  'chat.deal.carousel_title': 'Deals',
  'chat.contact.carousel_title': 'Contacts',
  'chat.crm_list.title': 'CRM records: {entity}',
  'chat.crm_list.total': 'Total found: {count}',
  'chat.crm_list.more_available': 'More records available',
  'chat.crm_list.empty': 'No records match the selected conditions.',
  'chat.crm_list.source': 'These results come from verified CRM data.',
  'chat.crm_list.next_page': 'Next page',
  'chat.crm_list.next_page_prompt': 'Load the next page of this list',
  'chat.crm_list.next_page_source': 'Previous CRM list',
  'chat.crm_list.column.name': 'Name',
  'chat.crm_list.filter_equals': '{field}: {value}',
  'chat.crm_list.filter_contains': '{field}: "{value}"',
  'chat.crm_list.filter_any_of': '{field}: any of [{value}]',
  'chat.crm_list.filter_between': '{field}: {value}',
  'chat.crm_list.filter_gte': '{field}: from {value}',
  'chat.crm_list.filter_label': 'Filter',
  'chat.crm_list.window.today': 'today and overdue',
  'chat.crm_list.window.tomorrow': 'tomorrow',
  'chat.crm_list.window.week': 'this week',
  'chat.crm_list.entity.default': 'CRM records',
  'chat.crm_list.entity.deal': 'deals',
  'chat.crm_list.entity.task': 'tasks',
  'chat.crm_list.entity.contact': 'contacts',
  'chat.crm_list.entity.company': 'companies',
  'chat.crm_list.entity.document': 'documents',
  'chat.crm_list.entity.calendar_event': 'calendar events',
  'chat.crm_list.entity.note': 'notes',
  'chat.crm_list.entity.project': 'projects',
  'ai_chat.task_selection.proposal_ready':
    'The proposal is ready. Review the tasks and approve the change in the card. Tasks remain unchanged until approval.',
  'ai_chat.task_selection.proposal_failed':
    'I could not verify the selection or replace the pending proposal. This request did not change the tasks; refresh the selection before a new proposal.',
  'chat.crm_list.field.title': 'Title',
  'chat.crm_list.field.query': 'Search',
  'chat.crm_list.field.stage': 'Stage',
  'chat.crm_list.field.amount': 'Amount',
  'chat.crm_list.field.currency': 'Currency',
  'chat.crm_list.field.email': 'Email',
  'chat.crm_list.field.phone': 'Phone',
  'chat.crm_list.field.company': 'Company',
  'chat.crm_list.field.domain': 'Domain',
  'chat.crm_list.field.industry': 'Industry',
  'chat.crm_list.field.status': 'Status',
  'chat.crm_list.field.priority': 'Priority',
  'chat.crm_list.field.assignee': 'Assignee',
  'chat.crm_list.field.project': 'Project',
  'chat.crm_list.field.contact': 'Contact',
  'chat.crm_list.field.deal': 'Deal',
  'chat.crm_list.field.document': 'Document',
  'chat.crm_list.field.dueAt': 'Due date',
  'chat.crm_list.field.startsAt': 'Starts',
  'chat.crm_list.field.endsAt': 'Ends',
  'chat.crm_list.field.type': 'Type',
  'chat.crm_list.field.body': 'Text',
  'chat.action_plan.badge': 'Action plan',
  'chat.action_plan.stage': 'Stage',
  'chat.action_plan.open_tasks': 'Open tasks',
  'chat.action_plan.notes': 'Latest notes',
  'chat.action_plan.actions': 'Suggested actions',
  'chat.action_plan.rationale': 'Why',
  'chat.action_plan.due_at': 'Due date',
  'chat.action_plan.proposal_only':
    'This is just a proposal for now. Creating tasks will require separate confirmation.',
  'chat.action_plan.select': 'Select action',
  'chat.action_plan.create_tasks': 'Create selected tasks',
  'chat.action_plan.manual_confirm':
    'You can also write “I confirm the plan” in the chat - then approval will be created for all items of the last plan.',
  'chat.action_plan.priority.low': 'Low',
  'chat.action_plan.priority.medium': 'Medium',
  'chat.action_plan.priority.high': 'High',
  'chat.action_plan.priority.urgent': 'Urgent',
  'chat.email_draft.badge': 'Email draft',
  'chat.email_draft.template': 'Template',
  'chat.email_draft.recipient': 'Recipient',
  'chat.email_draft.body': 'Email body',
  'chat.email_draft.not_sent': 'This is a draft; the email has not been sent.',
  'chat.email_draft.send_for_approval': 'Request approval to send',
  'chat.email_draft.send_approval_command': 'Request approval to send the follow-up draft',
  'chat.usage': 'Cost of last answer: {cost} ₽',
  'chat.quick_follow_up': 'Write follow-up',
  'chat.quick_follow_up_prompt':
    "Prepare a follow-up letter for the current deal {dealId} using the draft_email tool. Tone: warm. Return the draft and don't call send_email.",
  'chat.crud_title': 'CRUD actions',
  'chat.crud_hint': 'Quick commands for notes and stage changes without manual JSON.',
  'chat.crud_note_label': 'Note text',
  'chat.crud_note_placeholder': 'For example: call back tomorrow after 12:00',
  'chat.crud_add_note': 'Prepare a note',
  'chat.crud_stage_label': 'New stage',
  'chat.crud_update_stage': 'Prepare stage change',
  'system_agent.title': 'System panel',
  'system_agent.subtitle': 'CRM system AI workspace',
  'system_agent.close': 'Close panel',
  'system_agent.description':
    'Quick access to the system AI workspace, recent sessions and markdown canvas.',
  'system_agent.open_chat': 'Open /chat',
  'system_agent.recent_sessions': 'Recent sessions',
  'system_agent.empty_sessions': 'No sessions yet',
  'chat_workspace.title': 'AI Workspace',
  'chat_workspace.heading': 'CRM system chat',
  'chat_workspace.subtitle':
    'Separate work surface for system AI sessions: projects and sessions on the left, chat in the center, markdown editor/preview on the right.',
  'chat_workspace.sessions_title': 'Project sessions',
  'chat_workspace.sessions_description':
    'The list uses real conversation records of the current workspace.',
  'chat_workspace.new_session': 'New system session',
  'chat_workspace.new_session_title': 'System session',
  'chat_workspace.session_fallback': 'System session',
  'chat_workspace.empty_sessions': 'Create your first system session',
  'chat_workspace.group.system': 'System',
  'chat_workspace.group.workspace': 'Workspace',
  'chat_workspace.group.deals': 'Deals',
  'chat_workspace.group.contacts': 'Contacts',
  'chat_workspace.context_global': 'global context',
  'chat_workspace.context_unspecified': 'no context specified',
  'chat_workspace.visibility_private': 'private',
  'chat_workspace.visibility_shared': 'shared',
  'chat_workspace.current_session': 'Current session',
  'chat_workspace.system_session': 'system',
  'chat_workspace.chat_title': 'Chat',
  'chat_workspace.chat_description': 'Central Ant Design X chat surface on CRM SSE runtime.',
  'chat_workspace.chat_placeholder': 'Write to the system assistant...',
  'chat_workspace.chat_send': 'Send',
  'chat_workspace.cockpit_eyebrow': 'Agent panel',
  'chat_workspace.cockpit_title': 'Your CRM team in one chat',
  'chat_workspace.cockpit_description':
    'Quick demo commands show how the agent finds data, analyzes risk, builds plans, and prepares safe actions.',
  'chat_workspace.quick_actions_title': 'Demo commands',
  'chat_workspace.agent_status_ready': 'Ready',
  'chat_workspace.agent_status_working': 'Working',
  'chat_workspace.quick.hot_leads': 'Show hot leads',
  'chat_workspace.quick.hot_leads_description':
    'Find priority opportunities and explain the next step.',
  'chat_workspace.quick.hot_leads_command': 'Hot leads',
  'chat_workspace.quick.hot_leads_prompt':
    "Show today's hot leads, explain why they matter, and suggest the next safe CRM step.",
  'chat_workspace.quick.deal_risk': 'Assess deal risk',
  'chat_workspace.quick.deal_risk_description':
    'Show a risk analysis demo. If the deal ID is unknown, ask the user to select a deal.',
  'chat_workspace.quick.deal_risk_command': 'Deal risk',
  'chat_workspace.quick.deal_risk_prompt':
    'Show how deal risk analysis works. If this chat has no dealId, briefly ask for it and explain which risk widget you will build.',
  'chat_workspace.quick.action_plan': 'Build an action plan',
  'chat_workspace.quick.action_plan_description':
    'Create a next-step plan and prepare task creation through approval.',
  'chat_workspace.quick.action_plan_command': 'Action plan',
  'chat_workspace.quick.action_plan_prompt':
    'Create a concise action plan for the CRM situation. Ask for a dealId if needed. Do not create tasks without approval.',
  'chat_workspace.quick.workspace_view': 'Build a CRM view',
  'chat_workspace.quick.workspace_view_description':
    'Generate a table or cards from CRM data through show_view.',
  'chat_workspace.quick.workspace_view_command': 'CRM view',
  'chat_workspace.quick.workspace_view_prompt':
    'Show a useful CRM view for a manager: open deals and tasks without a next step. Use show_view if there is enough data; otherwise ask one clarifying question.',
  'chat_workspace.workflow_title': 'Visible agent workflow',
  'chat_workspace.workflow_intent': '1. Intent',
  'chat_workspace.workflow_intent_hint':
    'The assistant turns a free-form request into a CRM command.',
  'chat_workspace.workflow_tools': '2. Tools',
  'chat_workspace.workflow_tools_hint':
    'Reads run immediately; changes only proceed through approval.',
  'chat_workspace.workflow_artifact': '3. Artifact',
  'chat_workspace.workflow_artifact_hint':
    'The response arrives as a card: risk, view, email draft, plan, or memory.',
  'chat_workspace.workflow_approval': '4. Approval',
  'chat_workspace.workflow_approval_hint':
    'Emails, tasks, and CRUD actions require user confirmation.',
  'chat_workspace.scenarios_title': 'Agent scenarios',
  'chat_workspace.scenarios_description':
    'Executable CRM scripts go through approval, LangGraph playbooks go through secure LLM requests.',
  'chat_workspace.llm_profile':
    'Profile: {endpoint}, temperature {temperature}, max tokens {maxTokens}. The keys are not read and are not shown.',
  'chat_workspace.executable_scenario_title': 'CRM executable: follow-up after 3 days',
  'chat_workspace.scenario_target_type': 'Scenario target type',
  'chat_workspace.scenario_target_deal': 'Deal',
  'chat_workspace.scenario_target_contact': 'Contact',
  'chat_workspace.scenario_target_id': 'Scenario target ID',
  'chat_workspace.scenario_target_id_placeholder': 'dealId or contactId',
  'chat_workspace.run_scenario': 'Prepare launch via approval',
  'chat_workspace.run_scenario_command_ref': 'Run scenario',
  'chat_workspace.playbook_title': 'LangGraph playbook',
  'chat_workspace.playbook_select': 'Selecting LangGraph playbook',
  'chat_workspace.send_playbook': 'Send playbook to chat',
  'chat_workspace.stage.discovery': 'discovery',
  'chat_workspace.stage.conversion': 'conversion',
  'chat_workspace.stage.retention': 'retention',
  'chat_workspace.stage.support': 'support',
  'chat_workspace.stage.orchestration': 'orchestration',
  'memory.title': 'Memory Browser',
  'memory.subtitle': 'View agent memory by L1/L2/L3 levels and L3 semantic search.',
  'memory.browser_title': 'Workspace memory',
  'memory.browser_description': 'L1 - session buffer, L2 - episodic memory, L3 - vector knowledge.',
  'memory.tabs_aria': 'Memory levels',
  'memory.search_label': 'Semantic search',
  'memory.search_placeholder': 'For example: best time to contact',
  'memory.search_submit': 'Find',
  'memory.search_loading': 'Searching from memory L3...',
  'memory.search_empty': 'Nothing was found for the query "{query}".',
  'memory.search_error': 'The semantic search failed',
  'memory.search_unavailable': 'Semantic search is not available yet',
  'memory.search_unavailable_hint': 'The embeddings provider is not wired in this environment.',
  'memory.score': 'Score: {score}',
  'memory.importance': 'Importance: {value}',
  'memory.empty': 'There are no entries yet.',
  'memory.load_error': 'Could not load memory',
  'memory.actions.edit': 'Edit',
  'memory.actions.forget': 'Forget',
  'memory.actions.save': 'Save',
  'memory.actions.cancel': 'Cancel',
  'memory.edit_title': 'Edit entry: {key}',
  'memory.save_error': 'Failed to save entry',
  'memory.forget_confirm': 'Forget this entry?',
  'memory.forget_description':
    'The agent will stop taking this fact into account in conversations.',
  'memory.field.value': 'Fact',
  'memory.field.value_required': 'Text cannot be empty',
  'memory.field.value_reembed_hint':
    'After editing, the vector will be recalculated - the search will find a record using the new formulation.',
  'memory.field.importance': 'Importance (1–5)',
  'memory.field.pinned': 'Pin',
  'dashboard.page.title': 'Home',
  'dashboard.page.subtitle': 'Welcome back. Here is what is happening across your systems.',
  'dashboard.customize.reset': 'Reset',
  'dashboard.customize.done': 'Done',
  'dashboard.error.load_failed': 'Some dashboard data failed to load',
  'dashboard.error.retry': 'Retry',
  'dashboard.customize.button': 'Customize',
  'dashboard.customize.add_widget': 'Add widget',
  'dashboard.customize.move_up': 'Move {label} up',
  'dashboard.customize.move_down': 'Move {label} down',
  'dashboard.customize.remove': 'Remove {label}',
  'dashboard.customize.add': 'Add {label}',
  'dashboard.customize.width': 'Width',
  'dashboard.customize.width_for': 'Width: {label}',
  'dashboard.customize.clear_width': 'Reset width',
  'dashboard.customize.local_hint':
    'Layout is saved locally on this device; width options apply on desktop, mobile stays a single column.',
  'dashboard.customize.width_label.one_third': '1/3',
  'dashboard.customize.width_label.half': '1/2',
  'dashboard.customize.width_label.two_thirds': '2/3',
  'dashboard.customize.width_label.full': 'Full width',
  'dashboard.customize.width_aria.one_third': 'One third width',
  'dashboard.customize.width_aria.half': 'Half width',
  'dashboard.customize.width_aria.two_thirds': 'Two thirds width',
  'dashboard.customize.width_aria.full': 'Full width',
  'dashboard.widgets.stats': 'Summary',
  'dashboard.widgets.focus': "Today's focus",
  'dashboard.widgets.pipelineBoard': 'Deal funnel',
  'dashboard.widgets.week': 'Week',
  'dashboard.widgets.revenueGoal': 'Monthly goal',
  'dashboard.widgets.telegramLeads': 'Telegram leads',
  'dashboard.widgets.savedViews': 'Saved views',
  'dashboard.widgets.workforce': 'AI signals',
  'dashboard.widgets.burndown': 'Deal dynamics',
  'dashboard.widgets.pipelines': 'Deal stages',
  'dashboard.widgets.activity': 'Last activity',
  'dashboard.widgets.calendar': 'Calendar',
  'dashboard.widgets.actions': 'Quick Actions',
  'dashboard.widgets.notifications': 'Notifications',
  'dashboard.widgets.openTasks': 'Open tasks',
  'dashboard.widgets.attentionQueue': 'Money at risk',
  'dashboard.widgets.myDay': 'My day',
  'dashboard.widgets.portfolio': 'Portfolio',
  'dashboard.widgets.budget': 'Budget',
  'dashboard.widgets.agents': 'Agents',
  'dashboard.widgets.trends': 'Trends',
  'dashboard.widgets.swarm': 'Swarm',
  'dashboard.widgets.heatmap': 'Heatmap',
  'dashboard.widgets.pipeburn': 'Pipeline burn',
  'dashboard.widgets.clock': 'Clock',
  'dashboard.widgets.notes': 'Recent notes',
  'dashboard.widgets.nexus': 'Nexus',
  'dashboard.widgets.island': 'Island',
  'dashboard.widgets.quote': 'Quote',
  'dashboard.widgets.flatmedia': 'Flatmedia',
  'dashboard.presets.ceo': 'CEO',
  'dashboard.presets.sales': 'Sales',
  'dashboard.presets.pm': 'PM',
  'dashboard.presets.dev': 'Dev',
  'dashboard.presets.creative': 'Design',
  'dashboard.presets.flatmedia': 'Flatmedia',
  'dashboard.presets.group': 'Dashboard presets',
  'dashboard.presets.more': 'More',
  'dashboard.stats.projects': 'Deals',
  'dashboard.stats.active': 'In progress',
  'dashboard.stats.tasks_done': 'Hot leads',
  'dashboard.stats.sessions': 'Active scenarios',
  'dashboard.stats.sessions_suffix': 'active',
  'dashboard.stats.success_rate': 'Won deals',
  'dashboard.stats.total_cost': 'Awaiting approval',
  'dashboard.focus.title': 'Attention Queue (Daily Focus)',
  'dashboard.focus.view_all': 'Show all',
  'dashboard.focus.empty': 'No urgent tasks or signals. Everything is under control.',
  'dashboard.focus.no_project': 'No project',
  'dashboard.focus.priority.high': 'High',
  'dashboard.focus.priority.mid': 'Medium',
  'dashboard.focus.priority.low': 'Low',
  'dashboard.focus.last_contact': 'contact',
  'dashboard.focus.pending_approval_title': 'Agent action approval required',
  'dashboard.focus.pending_approval_subtitle': 'Pending decision in approval queue',
  'dashboard.focus.no_next_step': 'No next action scheduled',
  'dashboard.focus.overdue_task': 'Overdue task',
  'dashboard.focus.today_meeting': 'Meeting today',
  'dashboard.focus.actions.decide': 'Review',
  'dashboard.focus.actions.view_deal': 'Open deal',
  'dashboard.focus.actions.plan_step': 'Schedule step',
  'dashboard.focus.actions.view_task': 'Open task',
  'dashboard.focus.actions.open_chat': 'Open AI chat',
  'dashboard.focus.prompts.deal_recovery':
    'Suggest next best action and action plan for deal "{dealTitle}".',
  'dashboard.focus.prompts.plan_step': 'Plan the next contact step for deal "{dealTitle}".',
  'chat.email_draft.copy_text': 'Copy text',
  'chat.email_draft.copied': 'Copied to clipboard',
  'chat.email_draft.edit': 'Edit',
  'chat.email_draft.save_edit': 'Done',
  'chat.email_draft.send_manual': 'Send manually',
  'chat.email_draft.manual_sent': 'Sent manually',
  'chat.email_draft.subject_label': 'Subject',
  'chat.email_draft.body_label': 'Body',
  'projects.copilot.suggestion_changes': 'What changed in this project?',
  'projects.copilot.suggestion_changes_prompt':
    'Analyze current project {projectName} ({projectId}): what recent updates occurred across tasks, notes, and meetings?',
  'projects.copilot.suggestion_next_steps': 'What are next task steps?',
  'projects.copilot.suggestion_next_steps_prompt':
    'Analyze tasks for project {projectName} ({projectId}) and recommend prioritized next actions.',
  'projects.copilot.suggestion_brief': 'Generate project brief',
  'projects.copilot.suggestion_brief_prompt':
    'Generate a concise brief for project {projectName} ({projectId}): goals, members, current progress, and blockers.',
  'dashboard.workforce.title': 'AI signals',
  'dashboard.workforce.active_count': '{count} active',
  'dashboard.workforce.empty': 'There are no active signals yet',
  'dashboard.workforce.signal.scenario_run': 'Active scenario',
  'dashboard.workforce.signal.pending_approval': 'Awaiting confirmation',
  'dashboard.workforce.type.opencode': 'opencode',
  'dashboard.workforce.type.antigravity': 'antigravity',
  'dashboard.workforce.type.agent': 'agent',
  'dashboard.burndown.title': 'Deal dynamics',
  'dashboard.burndown.empty': 'There is not enough history to show deal trends yet.',
  'dashboard.burndown.ideal': 'Plan',
  'dashboard.burndown.remaining': 'Remaining',
  'dashboard.pipelines.title': 'Deal stages',
  'dashboard.pipeline_board.title': 'Deal funnel',
  'dashboard.pipeline_board.column.new': 'New',
  'dashboard.pipeline_board.column.progress': 'In progress',
  'dashboard.pipeline_board.column.payment': 'To payment',
  'dashboard.pipeline_board.kanban_link': 'Kanban',
  'dashboard.pipeline_board.empty': 'No deals in the funnel yet',
  'dashboard.pipeline_board.hint_today': 'today',
  'dashboard.pipeline_board.hint_overdue': 'overdue',
  'dashboard.week_strip.events_count': '{count} events',
  'dashboard.week_strip.calendar_link': 'Calendar',
  'dashboard.week_strip.empty': 'No events this week',
  'dashboard.revenue_goal.title': 'Monthly goal',
  'dashboard.revenue_goal.open': 'Deals',
  'dashboard.revenue_goal.of': 'of',
  'dashboard.revenue_goal.days_left': {
    one: '{count} day left in the month',
    few: '{count} days left in the month',
    many: '{count} days left in the month',
    other: '{count} days left in the month',
  },
  'dashboard.revenue_goal.progress_label': 'Monthly goal progress',
  'dashboard.telegram_leads.title': 'Telegram leads',
  'dashboard.telegram_leads.open': 'Queue',
  'dashboard.telegram_leads.pending': 'awaiting review',
  'dashboard.telegram_leads.empty': 'No new leads',
  'dashboard.telegram_leads.no_access': 'Owner and admin only',
  'dashboard.pipelines.empty': 'There are no active stages yet',
  'dashboard.activity.title': 'Last activity',
  'dashboard.activity.events_count': '{count} events',
  'dashboard.activity.empty': 'No recent activity yet',
  'dashboard.activity.fallback_title': 'Activity',
  'dashboard.activity.kind.deal_created': 'Deal created',
  'dashboard.activity.kind.deal_updated': 'Deal updated',
  'dashboard.activity.kind.deal_stage_changed': 'Deal stage changed',
  'dashboard.activity.kind.deal_deleted': 'Deal deleted',
  'dashboard.activity.kind.contact_created': 'Contact created',
  'dashboard.activity.kind.contact_updated': 'Contact updated',
  'dashboard.activity.kind.contact_deleted': 'Contact deleted',
  'dashboard.activity.kind.email_sent': 'Email sent',
  'dashboard.activity.kind.email_opened': 'Email opened',
  'dashboard.activity.kind.email_clicked': 'Email link clicked',
  'dashboard.activity.kind.call_made': 'Call made',
  'dashboard.activity.kind.meeting_scheduled': 'Meeting scheduled',
  'dashboard.activity.kind.meeting_updated': 'Meeting updated',
  'dashboard.activity.kind.meeting_cancelled': 'Meeting cancelled',
  'dashboard.activity.kind.note_added': 'Note added',
  'dashboard.activity.kind.note_updated': 'Note updated',
  'dashboard.activity.kind.note_deleted': 'Note deleted',
  'dashboard.activity.kind.ai_tool_invoked': 'AI tool invoked',
  'dashboard.activity.kind.scenario_started': 'Scenario started',
  'dashboard.activity.kind.scenario_completed': 'Scenario completed',
  'dashboard.activity.kind.task_created': 'Task created',
  'dashboard.activity.kind.task_updated': 'Task updated',
  'dashboard.activity.kind.task_status_changed': 'Task status changed',
  'dashboard.activity.kind.task_deleted': 'Task deleted',
  'dashboard.activity.kind.task_due_reminder': 'Task due reminder',
  'dashboard.activity.kind.company_created': 'Company created',
  'dashboard.activity.kind.company_updated': 'Company updated',
  'dashboard.activity.kind.company_deleted': 'Company deleted',
  'dashboard.activity.kind.interaction_logged': 'Interaction logged',
  'dashboard.activity.kind.interaction_updated': 'Interaction updated',
  'dashboard.activity.kind.interaction_deleted': 'Interaction deleted',
  'dashboard.activity.kind.document_created': 'Document created',
  'dashboard.activity.kind.document_updated': 'Document updated',
  'dashboard.activity.kind.document_deleted': 'Document deleted',
  'dashboard.activity.kind.template_created': 'Template created',
  'dashboard.activity.kind.template_updated': 'Template updated',
  'dashboard.activity.kind.template_deleted': 'Template deleted',
  'dashboard.activity.kind.project_created': 'Project created',
  'dashboard.activity.kind.project_updated': 'Project updated',
  'dashboard.activity.kind.project_deleted': 'Project deleted',
  'dashboard.activity.kind.attachment_added': 'Attachment added',
  'dashboard.activity.kind.attachment_deleted': 'Attachment deleted',
  'dashboard.activity.kind.entity_link_added': 'Link added',
  'dashboard.activity.kind.entity_link_removed': 'Link removed',
  'dashboard.calendar.title': 'Upcoming actions',
  'dashboard.calendar.empty': 'No upcoming actions yet',
  'dashboard.calendar.overdue': 'overdue',
  'dashboard.calendar.today': 'Today',
  'dashboard.calendar.tomorrow': 'Tomorrow',
  'dashboard.calendar.in_days': 'in {count}d',
  'dashboard.actions.title': 'Quick Actions',
  'dashboard.actions.new_project.label': 'New project',
  'dashboard.actions.new_project.subtitle': 'Create a workspace',
  'dashboard.actions.summon_agent.label': 'Ask AI',
  'dashboard.actions.summon_agent.subtitle': 'Quickly launch the assistant',
  'dashboard.actions.new_pipeline.label': 'New pipeline',
  'dashboard.actions.new_pipeline.subtitle': 'Set up work stages',
  'dashboard.actions.analytics.label': 'Analytics',
  'dashboard.actions.analytics.subtitle': 'View metrics',
  'dashboard.actions.settings.label': 'Settings',
  'dashboard.actions.settings.subtitle': 'System settings',
  'dashboard.notifications.title': 'Notifications',
  'dashboard.notifications.mark_all_read': 'Mark all read',
  'dashboard.notifications.empty': 'No notifications yet',
  'dashboard.notifications.approval.title': 'Agent action needs approval',
  'dashboard.notifications.approval.body': 'Action "{kind}" is waiting in the approval queue',
  'dashboard.notifications.approval.kind.tool_call': 'Tool call',
  'dashboard.notifications.approval.kind.scenario_step': 'Scenario step',
  'dashboard.notifications.approval.kind.contact_delete': 'Contact deletion',
  'dashboard.notifications.approval.kind.deal_delete': 'Deal deletion',
  'dashboard.notifications.hot_lead.title': 'Hot deal: {title}',
  'dashboard.notes.title': 'Recent notes',
  'dashboard.notes.view_all': 'View all',
  'dashboard.notes.empty': 'No notes yet',
  'dashboard.notes.unknown_author': 'Unknown author',
  'dashboard.open_tasks.title': 'Open tasks',
  'dashboard.open_tasks.view_all': 'View all',
  'dashboard.open_tasks.empty': 'No open tasks',
  'dashboard.open_tasks.no_due': 'No due date',
  'dashboard.open_tasks.status.todo': 'To do',
  'dashboard.open_tasks.status.in_progress': 'In progress',
  'dashboard.open_tasks.status.blocked': 'Blocked',
  'dashboard.my_day.title': 'My day',
  'dashboard.my_day.priority.meetings': 'Meetings',
  'dashboard.my_day.priority.overdue_tasks': 'Overdue tasks',
  'dashboard.my_day.priority.risk_deals': 'Deals at risk',
  'dashboard.my_day.priority.hot_leads': 'Hot deals',
  'dashboard.my_day.meetings': "Today's meetings",
  'dashboard.my_day.hot_leads': 'Hot deals',
  'dashboard.my_day.overdue_tasks': 'Overdue tasks',
  'dashboard.my_day.risk_deals': 'Deals at risk',
  'dashboard.my_day.pipeline': 'Pipeline',
  'dashboard.my_day.conversion': 'Conversion',
  'dashboard.my_day.empty': 'All clear for today',
  'dashboard.my_day.error': 'Failed to load the day summary',
  'dashboard.my_day.retry': 'Retry',
  'dashboard.my_day.run_ai': 'Open AI review: {label}',
  'dashboard.my_day.no_priority_records': 'No records to review',
  'dashboard.my_day.propose_strategy': 'Strategy',
  'dashboard.my_day.sales_health.title': 'Sales health',
  'dashboard.my_day.sales_health.active': 'Active deals',
  'dashboard.my_day.sales_health.attention': 'Need attention',
  'dashboard.my_day.sales_health.critical': 'Critical',
  'dashboard.my_day.sales_health.level_healthy': 'Healthy',
  'dashboard.my_day.sales_health.level_attention': 'Attention',
  'dashboard.my_day.sales_health.level_critical': 'Critical',
  'dashboard.my_day.sales_health.empty': 'The open pipeline is empty — no forecast yet.',
  'dashboard.my_day.sales_health.all_healthy': 'Every pipeline deal is healthy.',
  'dashboard.my_day.sales_health.error': 'Could not load sales health',
  'dashboard.my_day.sales_health.disclaimer':
    'Read-only CRM heuristic: stage + risk signals. No data was changed.',
  'dashboard.agent_widgets.title': 'Agent widgets',
  'dashboard.agent_widgets.remove_block': 'Remove {label} block',
  'dashboard.time.just_now': 'just now',
  'dashboard.time.minutes_ago': '{count}m ago',
  'dashboard.time.hours_ago': '{count}h ago',
  'dashboard.time.days_ago': '{count}d ago',
  'approvals.summary.create_calendar_event': 'Create a calendar event',
  'approvals.summary.update_calendar_event': 'Update the calendar event',
  'approvals.summary.cancel_calendar_event': 'Cancel the calendar event',
  'approvals.summary.reschedule_calendar_event': 'Reschedule the calendar event',
  'approvals.summary.link_calendar_event_participant': 'Add a calendar participant',
  'approvals.summary.unlink_calendar_event_participant': 'Remove a calendar participant',
  'approvals.summary.create_document': 'Create a document',
  'approvals.summary.update_document': 'Update the document',
  'approvals.summary.delete_document': 'Delete the document',
  'approvals.summary.link_document': 'Link the document',
  'approvals.summary.unlink_document': 'Unlink the document',
  'approvals.summary.transition_document_status': 'Change the document status',
  'approvals.summary.create_template': 'Create a template',
  'approvals.summary.update_template': 'Update the template',
  'approvals.summary.delete_template': 'Delete the template',
  'approvals.summary.activate_template': 'Activate the template',
  'approvals.summary.deactivate_template': 'Deactivate the template',
  'approvals.summary.link_attachment': 'Link the attachment',
  'approvals.summary.unlink_attachment': 'Unlink the attachment',
  'approvals.summary.delete_attachment': 'Delete the attachment',
  'approvals.bulk.summary.create_calendar_events': 'Create calendar events in bulk',
  'approvals.bulk.summary.update_calendar_events': 'Update calendar events in bulk',
  'approvals.bulk.summary.cancel_calendar_events': 'Cancel calendar events in bulk',
  'approvals.bulk.summary.reschedule_calendar_events': 'Reschedule calendar events in bulk',
  'approvals.bulk.summary.link_calendar_event_participants': 'Add calendar participants in bulk',
  'approvals.bulk.summary.unlink_calendar_event_participants':
    'Remove calendar participants in bulk',
  'approvals.bulk.summary.create_contact_interactions': 'Create contact interactions in bulk',
  'approvals.bulk.summary.update_contact_interactions': 'Update contact interactions in bulk',
  'approvals.bulk.summary.delete_contact_interactions': 'Delete contact interactions in bulk',
  'approvals.bulk.summary.create_documents': 'Create documents in bulk',
  'approvals.bulk.summary.update_documents': 'Update documents in bulk',
  'approvals.bulk.summary.delete_documents': 'Delete documents in bulk',
  'approvals.bulk.summary.create_templates': 'Create templates in bulk',
  'approvals.bulk.summary.update_templates': 'Update templates in bulk',
  'approvals.bulk.summary.delete_templates': 'Delete templates in bulk',
  'approvals.bulk.summary.activate_templates': 'Activate templates in bulk',
  'approvals.bulk.summary.deactivate_templates': 'Deactivate templates in bulk',
  'approvals.bulk.summary.link_attachments': 'Link attachments in bulk',
  'approvals.bulk.summary.unlink_attachments': 'Unlink attachments in bulk',
  'approvals.bulk.summary.delete_attachments': 'Delete attachments in bulk',
  'ai_chat.action_plan.title': 'Requested actions',
  'ai_chat.action_plan.approve': 'Confirm action',
  'ai_chat.action_plan.reject': 'Reject',
  'ai_chat.action_plan.undo': 'Undo',
  'ai_chat.action_plan.empty_value': 'Not specified',
  'ai_chat.action_plan.blocked_dependency': 'Available after the preceding action completes.',
  'ai_chat.action_plan.stale_details':
    'The record changed after this action completed. Review the current data before undoing it.',
  'ai_chat.action_plan.status.blocked': 'Waiting for previous action',
  'ai_chat.action_plan.status.pending': 'Awaiting confirmation',
  'ai_chat.action_plan.status.approved': 'Confirmed',
  'ai_chat.action_plan.status.rejected': 'Rejected',
  'ai_chat.action_plan.status.succeeded': 'Completed',
  'ai_chat.action_plan.status.failed': 'Failed',
  'ai_chat.action_plan.status.cancelled': 'Cancelled',
  'ai_chat.action_plan.status.undo_pending': 'Undo awaiting confirmation',
  'ai_chat.action_plan.status.undone': 'Undone',
  'ai_chat.action_plan.status.stale': 'Data changed',
  'ai_chat.action_plan.entity.company': 'Company',
  'ai_chat.action_plan.entity.contact': 'Contact',
  'ai_chat.action_plan.entity.deal': 'Deal',
  'ai_chat.action_plan.entity.task': 'Task',
  'ai_chat.action_plan.entity.note': 'Note',
  'ai_chat.action_plan.entity.calendar_event': 'Calendar event',
  'ai_chat.action_plan.entity.contact_interaction': 'Interaction',
  'ai_chat.action_plan.action.create_company': 'Create company',
  'ai_chat.action_plan.action.create_contact': 'Create contact',
  'ai_chat.action_plan.action.create_deal': 'Create deal',
  'ai_chat.action_plan.action.create_task': 'Create task',
  'ai_chat.task_kanban.title': 'Deal tasks',
  'ai_chat.task_kanban.error': 'Failed to load tasks',
  'ai_chat.task_kanban.expand': 'Expand task board',
  'ai_chat.task_kanban.collapse': 'Collapse task board',
  'ai_chat.task_kanban.create': 'Create task',
  'ai_chat.action_plan.action.create_calendar_event': 'Schedule appointment',
  'ai_chat.action_plan.action.create_contact_interaction': 'Log a contact interaction',
  'ai_chat.action_plan.action.create_note': 'Create note',
  'ai_chat.action_plan.action.create_document': 'Create document',
  'ai_chat.action_plan.action.create_template': 'Create template',
  'ai_chat.action_plan.action.update_task': 'Update task',
  'ai_chat.action_plan.action.update_company': 'Update company',
  'ai_chat.action_plan.action.update_contact': 'Update contact',
  'ai_chat.action_plan.action.update_deal': 'Update deal',
  'ai_chat.action_plan.action.update_note': 'Update note',
  'ai_chat.action_plan.action.update_document': 'Update document',
  'ai_chat.action_plan.action.update_template': 'Update template',
  'ai_chat.action_plan.action.update_calendar_event': 'Update appointment',
  'ai_chat.action_plan.action.delete_company': 'Delete company',
  'ai_chat.action_plan.action.delete_contact': 'Delete contact',
  'ai_chat.action_plan.action.delete_deal': 'Delete deal',
  'ai_chat.action_plan.action.delete_task': 'Delete task',
  'ai_chat.action_plan.action.delete_note': 'Delete note',
  'ai_chat.action_plan.action.delete_document': 'Delete document',
  'ai_chat.action_plan.action.delete_template': 'Delete template',
  'ai_chat.action_plan.action.cancel_calendar_event': 'Cancel appointment',
  'ai_chat.action_plan.undo_used_downstream':
    'The result is used by a later step, so undo is unavailable.',
  'ai_chat.action_plan.entity.document': 'Document',
  'ai_chat.action_plan.entity.template': 'Template',
  'ai_chat.action_plan.action.bulk_group_apply': 'Bulk operation',
  'ai_chat.action_plan.bulk.total': 'Total targets: {count}',
  'ai_chat.action_plan.bulk.succeeded': 'Succeeded: {count}',
  'ai_chat.action_plan.bulk.failed': 'Failed: {count}',
  'ai_chat.action_plan.bulk.skipped': 'Skipped: {count}',
  'ai_chat.action_plan.bulk.stale': 'Changed: {count}',
  'ai_chat.action_plan.bulk.unfinished': 'Unfinished: {count}',
  'ai_chat.action_plan.bulk.sample_title': 'Items (first {count})',
  'ai_chat.action_plan.bulk.item_status.pending': 'Pending',
  'ai_chat.action_plan.bulk.item_status.succeeded': 'Succeeded',
  'ai_chat.action_plan.bulk.item_status.failed': 'Failed',
  'ai_chat.action_plan.bulk.item_status.skipped': 'Skipped',
  'ai_chat.action_plan.bulk.item_status.stale': 'Changed',
  'telegram.approval.completed': 'Completed',
  'telegram.approval.rejected': 'Rejected',
  'telegram.approval.expired': 'Approval expired',
  'telegram.approval.not_completed': 'Approved, but the operation was not completed',
  'telegram.approval.approve': 'Approve',
  'telegram.approval.reject': 'Reject',
  'ai_chat.action_plan.retry_prepared':
    'A new retry approval is ready. The operation has not executed yet.',
  'ai_chat.action_plan.retry_before_effect':
    'The step stopped before execution. A retry requires a new approval.',
  'ai_chat.action_plan.retry': 'Retry step',
  'ai_chat.action_plan.retry_failed':
    'Could not prepare a retry. Refresh the plan and check the step status.',
  'ai_chat.action_plan.bulk.retry': 'Finish remaining',
  'ai_chat.action_plan.action.unspecified': 'CRM action',
  'ai_chat.action_plan.field.name': 'Name',
  'ai_chat.action_plan.field.first_name': 'First name',
  'ai_chat.action_plan.field.last_name': 'Last name',
  'ai_chat.action_plan.field.phone': 'Phone',
  'ai_chat.action_plan.field.email': 'Email',
  'ai_chat.action_plan.field.title': 'Title',
  'ai_chat.action_plan.field.amount': 'Amount',
  'ai_chat.action_plan.field.stage': 'Stage',
  'ai_chat.action_plan.field.company': 'Company',
  'ai_chat.action_plan.field.contact': 'Contact',
  'ai_chat.action_plan.field.deal': 'Deal',
  'ai_chat.action_plan.field.due_at': 'Due date',
  'ai_chat.action_plan.field.description': 'Description',
  'ai_chat.action_plan.field.priority': 'Priority',
  'ai_chat.action_plan.field.starts_at': 'Starts at',
  'ai_chat.action_plan.field.ends_at': 'Ends at',
  'ai_chat.action_plan.field.timezone': 'Time zone',
  'ai_chat.action_plan.field.location': 'Location',
  'ai_chat.action_plan.field.type': 'Type',
  'ai_chat.action_plan.field.subject': 'Subject',
  'ai_chat.action_plan.field.body': 'Content',
  'ai_chat.action_plan.field.channel': 'Channel',
  'ai_chat.action_plan.field.occurred_at': 'Occurred at',

  // Run Center (automation journal)
  'run_center.title': 'Run Center',
  'run_center.subtitle':
    'Automation journal: which scenarios ran, for which deals and with what result. Status changes appear automatically.',
  'run_center.stats.total': 'Total runs',
  'run_center.stats.running': 'Running',
  'run_center.stats.awaiting': 'Awaiting approval',
  'run_center.stats.completed': 'Completed',
  'run_center.stats.failed': 'Failures',
  'run_center.filter.scenario': 'Filter by scenario',
  'run_center.filter.status': 'Filter by status',
  'run_center.filter.all_scenarios': 'All scenarios',
  'run_center.filter.all_statuses': 'All statuses',
  'run_center.refresh': 'Refresh the journal',
  'run_center.column.scenario': 'Scenario',
  'run_center.column.deal': 'Deal',
  'run_center.column.contact': 'Contact',
  'run_center.column.status': 'Status',
  'run_center.column.started': 'Started',
  'run_center.not_started': 'Not started yet',
  'run_center.column.finished': 'Finished',
  'run_center.column.scheduled': 'Next attempt',
  'run_center.column.attempts': 'Attempts',
  'run_center.column.outcome': 'Result',
  'run_center.status.queued': 'Queued',
  'run_center.status.running': 'Running',
  'run_center.status.awaiting_approval': 'Waiting for approval',
  'run_center.status.completed': 'Completed',
  'run_center.status.failed': 'Failed',
  'run_center.status.cancelled': 'Cancelled',
  'run_center.outcome.queued': 'Waiting to start',
  'run_center.outcome.in_progress': 'In progress',
  'run_center.outcome.waiting_approval': 'Waiting for your approval',
  'run_center.outcome.follow_up_queued': 'Email queued for delivery',
  'run_center.outcome.skipped': 'Skipped: no matching data',
  'run_center.outcome.completed': 'Finished without data changes',
  'run_center.outcome.failed': 'Failed',
  'run_center.outcome.cancelled': 'Cancelled',
  'run_center.outcome.unknown': 'No data changes',
  'run_center.approval_link': 'Needs a decision',
  'run_center.empty.title': 'No runs yet',
  'run_center.empty.description':
    'Scenario runs will appear here — for example, after a deal moves to the Contacted stage.',
  'run_center.error.title': 'Could not load the run journal',
  'run_center.error.description': 'Check the connection and try again.',
  'run_center.preset.follow_up.name': 'Follow-up after 3 days',
  'run_center.preset.graph_follow_up.name': 'Follow-up after 3 days (graph)',
  'run_center.preset.my_day.name': 'Morning My Day',
  'run_center.scheduled_occurrence': '{date} at {time} ({timezone})',
  'run_center.my_day.summary':
    'Meetings: {meetings} · Overdue tasks: {overdue} · Risk deals: {risks} · Hot leads: {leads}',
  'run_center.my_day.summary_truncated': '{summary} · lists truncated',
  'run_center.column.actions': 'Actions',
  'run_center.column.approval': 'Approval',
  'run_center.action.cancel': 'Cancel',
  'run_center.action.retry': 'Retry',
  'run_center.action.cancel_selected': 'Cancel selected ({count})',
  'run_center.action.retry_selected': 'Retry selected ({count})',
  'run_center.confirm.cancel_title': 'Cancel run?',
  'run_center.confirm.cancel_description':
    'The awaiting approval run will be cancelled. The linked approval will be cancelled as well.',
  'run_center.confirm.retry_title': 'Retry run?',
  'run_center.confirm.retry_description':
    'The run will be queued again with attempts reset to zero.',
  'run_center.success.cancelled': 'Run cancelled',
  'run_center.success.retried': 'Run queued again',
  'run_center.error.cancel_failed': 'Could not cancel run',
  'run_center.error.retry_failed': 'Could not retry run',
  'run_center.bulk.mixed_cancel_tooltip':
    'Selected runs have mixed statuses — cancel is available only for awaiting approval',
  'run_center.bulk.mixed_retry_tooltip':
    'Selected runs have mixed statuses — retry is available only for failed',
  'run_center.bulk.cancel_confirm_title': 'Cancel selected runs?',
  'run_center.bulk.cancel_confirm_description': 'Runs to cancel: {count}',
  'run_center.bulk.retry_confirm_title': 'Retry selected runs?',
  'run_center.bulk.retry_confirm_description': 'Runs to queue: {count}',
  'run_center.upgrade.title': 'Pro plan required',
  'run_center.upgrade.description':
    'Run Center is available on Pro and Agency plans: automation journal, scenario runs and one-click cancellation.',
  'run_center.upgrade.action': 'Upgrade to Pro',

  // Automations preset library
  'automations.title': 'Automations',
  'automations.subtitle':
    'A catalog of ready-made automations. Enable Follow-up after 3 days to automatically create runs after deals move to Contacted.',
  'automations.loading': 'Loading automations...',
  'automations.empty_title': 'No automations available',
  'automations.empty_description': 'Presets will appear after demo data is refreshed.',
  'automations.error_title': 'Could not load automations',
  'automations.enabled': 'Enabled',
  'automations.disabled': 'Disabled',
  'automations.toggle_on': 'Enable',
  'automations.toggle_off': 'Disable',
  'automations.trigger': 'Trigger',
  'automations.condition': 'Condition',
  'automations.outcome': 'Outcome',
  'automations.run_center_link': 'Open in Run Center',
  'automations.run_center_aria': 'Open runs of scenario {name} in Run Center',
  'automations.toggle_aria': 'Toggle automation {name}',
  'automations.updated': 'State updated',
  'automations.update_failed': 'Could not update state. Please try again.',
  'automations.refresh': 'Refresh',
  'automations.refresh_aria': 'Refresh automations list',
  'automations.preset.follow_up.name': 'Follow-up after 3 days',
  'automations.preset.follow_up.description':
    'After a deal moves to Contacted, wait 3 days, draft a follow-up email and request approval.',
  'automations.preset.follow_up.trigger': 'Event',
  'automations.preset.follow_up.condition': 'Deal moves to Contacted',
  'automations.preset.follow_up.outcome': 'Wait 3 days → draft follow-up email → request approval',
  'automations.preset.graph_follow_up.name': 'Follow-up after 3 days',
  'automations.preset.graph_follow_up.description':
    'After a deal moves to Contacted, wait 3 days, analyze risk, then request approval to queue a follow-up email.',
  'automations.preset.graph_follow_up.trigger': 'Event',
  'automations.preset.graph_follow_up.condition': 'Deal moves to Contacted',
  'automations.preset.graph_follow_up.outcome':
    'Wait 3 days → risk analysis → approval → queued email',
  'automations.preset.my_day.name': 'Morning My Day',
  'automations.preset.my_day.description':
    'Every morning at 09:00 (Europe/Moscow), build a read-only My Day briefing and finish with a short summary.',
  'automations.preset.my_day.trigger': 'Scheduled',
  'automations.preset.my_day.schedule': 'Daily at 09:00 (Europe/Moscow)',
  'automations.preset.my_day.condition': '09:00 Europe/Moscow arrives',
  'automations.preset.my_day.outcome': 'My Day briefing → short summary in Run Center',
  'automations.preset.conversion_digest.name': 'Conversion digest',
  'automations.preset.conversion_digest.description':
    'Daily builds ONE conversion digest post: top-5 hot deals with reason and next step plus deals untouched for N days. The hour and N come from the conversion digest subscription in the Telegram settings.',
  'automations.preset.conversion_digest.trigger': 'Scheduled',
  'automations.preset.conversion_digest.schedule':
    'Daily at the subscribed hour (workspace time zone)',
  'automations.preset.conversion_digest.condition': 'The subscribed delivery hour arrives',
  'automations.preset.conversion_digest.outcome':
    'One post → Telegram (separate consent) or a CRM note',
  'conversion_digest.post.title': 'Conversion digest — {date}',
  'conversion_digest.post.top_title': 'Top deals',
  'conversion_digest.post.top_empty': 'No hot deals right now.',
  'conversion_digest.post.reason': 'Reason',
  'conversion_digest.post.next_step': 'Next step',
  'conversion_digest.post.stagnation_title': 'No touch for {days}+ days',
  'conversion_digest.post.stagnation_empty': 'No untouched deals.',
  'conversion_digest.post.more': '…and {count} more',
  'conversion_digest.post.days': '{count} d',
  'conversion_digest.reason.overdue_next_activity': 'next action is overdue',
  'conversion_digest.reason.overdue_task': 'deal task is overdue',
  'conversion_digest.reason.missing_next_activity': 'no next action planned',
  'conversion_digest.reason.stale_activity': 'no recent activity',
  'conversion_digest.reason.due': 'next action is due soon',
  'conversion_digest.reason.high_value': 'high-value deal',
  'conversion_digest.next_step.email': 'send an email',
  'conversion_digest.next_step.call': 'make a call',
  'automations.trigger_type.event': 'Event',
  'automations.trigger_type.manual': 'Manual',
  'automations.trigger_type.scheduled': 'Scheduled',
  'automations.more': 'more',
  'automations.generic.condition': 'Condition is defined by configuration',
  'automations.generic.outcome': 'Outcome is defined by scenario steps',
  'automations.edit_aria': 'Edit automation {name}',
  'automations.graph_edit_unavailable':
    'Graph editing is not available yet — use the toggle and Run Center',
  'automations.scheduled_edit_unavailable':
    'Schedule editing is not available yet — use the toggle and Run Center',
  'automations.duplicate_aria': 'Duplicate automation {name}',
  'automations.create': 'New scenario',

  // Canonical workflow graph editor
  'graph_scenario_editor.create_title': 'New graph automation',
  'graph_scenario_editor.edit_title': 'Edit graph automation',
  'graph_scenario_editor.subtitle':
    'A verified workflow: Contacted event, 3-day wait, risk analysis, approval, then an email is queued.',
  'graph_scenario_editor.name_placeholder': 'e.g. Follow-up after 3 days',
  'graph_scenario_editor.active': 'Enable after saving',
  'graph_scenario_editor.active_hint':
    'When enabled, new matching deal transitions will create runs automatically.',
  'graph_scenario_editor.flow': 'Verified workflow',
  'graph_scenario_editor.trigger': 'Trigger',
  'graph_scenario_editor.wait': 'Wait',
  'graph_scenario_editor.wait_value': '3 days',
  'graph_scenario_editor.analysis': 'Risk analysis',
  'graph_scenario_editor.approval': 'Approval',
  'graph_scenario_editor.approval_value': 'Required before the email action',
  'graph_scenario_editor.action': 'Action after approval',
  'graph_scenario_editor.subject': 'Email subject',
  'graph_scenario_editor.body': 'Email body',
  'graph_scenario_editor.create': 'Create graph scenario',
  'graph_scenario_editor.edit_action': 'Edit existing graph',
  'graph_scenario_editor.created': 'Graph scenario created',
  'graph_scenario_editor.saved': 'Graph scenario saved',
  'graph_scenario_editor.activation_failed':
    'The scenario was created but could not be enabled. You can enable it from the automation card.',

  // Scenario editor (ADR-030 variant B) — Master-Detail Drawer
  'scenario_editor.title': 'Scenario editor',
  'scenario_editor.library_title': 'Automations',
  'scenario_editor.drawer_title': 'Edit scenario',
  'scenario_editor.drawer_subtitle': 'Preset: {name} · version {version}',
  'scenario_editor.loading': 'Loading scenario…',
  'scenario_editor.load_error': 'Could not load scenario',
  'scenario_editor.save': 'Save',
  'scenario_editor.saving': 'Saving…',
  'scenario_editor.save_success': 'Scenario saved (v{version})',
  'scenario_editor.save_error': 'Could not save scenario',
  'scenario_editor.validation_error': 'Check fields and try again',
  'scenario_editor.version_conflict': 'Version conflict — reload and try again',
  'scenario_editor.forbidden': 'Not enough permissions',
  'scenario_editor.upgrade_needed': 'Upgrade to create more active scenarios',
  'scenario_editor.duplicate': 'Duplicate',
  'scenario_editor.duplicate_success': 'Scenario duplicated',
  'scenario_editor.create_from_preset': 'Create from preset',
  'scenario_editor.create_from_preset_aria': 'Create scenario from preset {name}',
  'scenario_editor.create_success': 'Scenario created',
  'scenario_editor.preset_picker_title': 'Choose preset',
  'scenario_editor.preset_picker_empty': 'No presets available',
  'scenario_editor.preset_key_label': 'Preset key',
  'scenario_editor.config_label': 'Configuration (JSON)',
  'scenario_editor.config_hint': 'Validated as ScenarioConfig {id, triggers, steps}',
  'scenario_editor.close': 'Close',
  'scenario_editor.cancel': 'Cancel',
  'scenario_editor.edit': 'Edit',
  'scenario_editor.field.name': 'Name',
  'scenario_editor.field.name_placeholder': 'e.g. Follow-up after 3 days',
  'scenario_editor.field.description': 'Description',
  'scenario_editor.field.trigger': 'Trigger',
  'scenario_editor.field.trigger_deal_stage': 'Deal stage -> Contacted',
  'scenario_editor.field.trigger_manual': 'Manual',
  'scenario_editor.field.trigger_scheduled': 'Scheduled',
  'scenario_editor.field.trigger_event': 'Event',
  'scenario_editor.field.wait_duration': 'Wait',
  'scenario_editor.field.wait_3d': 'Wait 3 days',
  'scenario_editor.field.steps': 'Steps',
  'scenario_editor.field.step_wait': 'Step 1 — Wait',
  'scenario_editor.field.step_tool': 'Step 2 — Send email (approval)',
  'scenario_editor.field.version': 'Version',
  'scenario_editor.field.isActive': 'Active',
  'scenario_editor.field.advanced_json': 'Advanced (JSON)',
  'scenario_editor.field.advanced_json_hint': 'Raw config for future steps — validated on save',
  'scenario_editor.retry': 'Retry',
  'scenario_editor.detail.version': 'v{version}',
  'scenario_editor.detail.updated': 'Updated {date}',
  'scenario_editor.detail.created': 'Created {date}',

  // Workflows deprecated (ADR-030)
  'workflows.deprecated_title': 'Workflows deprecated — use Automations',
  'workflows.deprecated_description':
    'The workflows editor has moved to Automations. Create a scenario from a preset and edit it in the Drawer.',
  'workflows.deprecated_link': 'Go to Automations',
  'workflows.title': 'Workflows (n8n-style)',
  'workflows.subtitle':
    'Graph: nodes (trigger/tool/llm/condition/delay) + edges. Run from chat via “run scenario X” (run_scenario) or on cron (cron in config).',
  'workflows.create_button': 'New workflow',
  'workflows.create_modal_title': 'New workflow',
  'workflows.empty':
    'No workflows yet. Create the first — it will appear here and be available from chat.',
  'workflows.run': 'Run',
  'workflows.active': 'active',
  'workflows.paused': 'paused',
  'workflows.form.name_label': 'Name',
  'workflows.form.name_placeholder': 'e.g. Follow-up after 3 days',
  'workflows.form.trigger_label': 'Trigger',
  'workflows.form.trigger_manual': 'Manual / from chat',
  'workflows.form.trigger_scheduled': 'Scheduled',
  'workflows.form.trigger_event': 'Event',
  'workflows.form.graph_label': 'Graph (JSON: { nodes, edges, cron })',
  'workflows.form.graph_placeholder':
    '{\n  "nodes": [{ "id": "trigger", "type": "trigger", "params": { "kind": "manual" } }, { "id": "t1", "type": "tool", "params": { "tool": "create_task", "args": { "title": "Follow-up" } } }],\n  "edges": [{ "from": "trigger", "to": "t1" }],\n  "cron": "0 9 * * *"\n}',
  'workflows.hint':
    'Hint: tool nodes map to any CRM tool (create_task, send_email, etc.), llm is a prompt step, condition is branching, delay is a pause. Cron is Crontab format, checked by the worker every minute.',
  'workflows.create_error': 'Failed to create workflow',

  // Imports preview
  'imports.preview.title': 'Preview: {totalRows} rows',
  'imports.preview.title_truncated':
    'Preview: showing first {shown} of {totalRows} rows (import limit reached)',

  // Pending invitations banner
  'pending_invitations.invited_message': 'You were invited to "{workspace}" as {role}',
  'pending_invitations.expires_info': 'Invitation for {email} · valid until {date}',
  'pending_invitations.accepted_message': 'Accepted — you are now a member of "{workspace}"',
  'pending_invitations.switch_workspace': 'Go to workspace',

  'deal_card.next_best_action_btn': 'Prepare follow-up',
  'dashboard.morning_briefing.title': 'Day briefing',
  'dashboard.morning_briefing.subtitle': 'A summary of today from your CRM data.',
  'dashboard.morning_briefing.expand': 'Expand',
  'dashboard.morning_briefing.ai_badge': 'AI',
  'dashboard.morning_briefing.collapse': 'Collapse',
  'dashboard.morning_briefing.hot_leads': 'hot deals',
  'dashboard.morning_briefing.overdue_tasks': 'overdue',
  'dashboard.morning_briefing.meetings': 'meetings today',
  'dashboard.morning_briefing.risk_deals': 'deals at risk',
  'dashboard.morning_briefing.conversion': 'conversion',
  'dashboard.morning_briefing.run_ai': 'Review with AI',
  'dashboard.morning_briefing.error': 'Failed to load the briefing',
  'dashboard.morning_briefing.retry': 'Retry',
  'dashboard.morning_briefing.empty':
    'Briefing data will appear once there is activity in the CRM.',
  'chat.compound.prepared':
    'The read is complete. The linked action is shown in the plan; review its status and approval card.',
  'chat.compound.ambiguous':
    'Several records match. Clarify which one to use; no write was prepared.',
  'chat.compound.empty': 'No record matched. The dependent action was not prepared.',
  'chat.compound.failed': 'The dependent action could not be safely prepared. CRM has not changed.',
  'chat.compound.stale': 'The source record changed. The dependent action was not prepared.',
  'chat.compound.conflict':
    'This request is already being processed or its saved version changed. No new action was created.',
  'chat.compound.unsupported':
    'A linked action cannot yet be safely prepared for this compound request. Please clarify it.',
  'chat.compound.step.read': 'Read',
  'chat.compound.step.write': 'Write',
  'chat.compound.selection_unknown':
    'The record could not be selected unambiguously. Enter its number or exact name from the list.',
  'chat.compound.selection_conflict':
    'This selection refers to an earlier plan version or the record has changed. Repeat the original request.',
  'chat.compound.selection_unavailable':
    'The saved selection is unavailable. Repeat the original request to get a current list.',
  'chat.compound.selection_used': 'This choice was already used — the action is prepared above.',
  'chat.compound.correction_prepared':
    'Correction saved. The previous approval was cancelled; review the new action.',
  'chat.compound.correction_conflict':
    'This action has changed or is no longer awaiting approval. Refresh the chat and repeat the correction.',
  'chat.compound.correction_clarification':
    'Specify which field to change: title, date and time, or contact.',
  'chat.compound.matching_records': 'Matching records:',
  'chat.compound.status.needs_clarification': 'Needs clarification',
  'chat.compound.status.pending': 'Pending',
  'chat.compound.status.blocked_by_dependency': 'Blocked by dependency',
  'chat.compound.status.failed': 'Failed',
  'chat.compound.status.awaiting_approval': 'Awaiting approval',
  'chat.compound.status.done': 'Done',
  'chat.compound.batch_prepared_one': 'Prepared {count} task. Confirm in order.',
  'chat.compound.batch_prepared_few': 'Prepared {count} tasks. Confirm in order.',
  'chat.compound.batch_prepared_many': 'Prepared {count} tasks. Confirm in order.',
  'chat.compound.batch_prepared_other': 'Prepared {count} tasks. Confirm in order.',
  'chat.compound.batch_write': 'Task · {label}',
  'chat.compound.status.cancelled': 'Removed',
  'chat.compound.batch_corrected': 'The plan has been updated.',
  'chat.compound.batch_bulk_title': 'Tasks updated: {count} — title “{value}”.',
  'chat.compound.batch_bulk_dueAt': 'Tasks updated: {count} — due {value}.',
  'chat.compound.batch_bulk_remove': 'All tasks in the plan were removed. The plan is closed.',
  'chat.compound.batch_bulk_skipped': 'Skipped: {items}.',
  'chat.compound.batch_bulk_time_required':
    'Specify a time for tasks {items}, for example “at 10:00”. The date and task set are saved; no changes have been applied yet.',
  'chat.compound.batch_no_open': 'There are no tasks in the plan that can be changed.',
  'chat.compound.batch_skip_removed': 'removed',
  'chat.compound.batch_skip_excluded': 'excluded from this correction',
  'chat.compound.batch_skip_succeeded': 'completed',
  'chat.compound.batch_skip_rejected': 'rejected',
  'chat.compound.batch_skip_expired': 'approval expired',
  'chat.compound.batch_skip_failed': 'failed',
  'chat.compound.batch_skip_cancelled': 'cancelled',
  'chat.compound.batch_skip_approved': 'already approved',
  'chat.compound.batch_skip_executing': 'executing',
  'chat.compound.batch_skip_undone': 'undone',
  'chat.compound.batch_skip_unavailable': 'unavailable for changes',
  'chat.compound.batch_time_required':
    'Specify a time for task {count}, for example “at 10:00”. The selected day is saved; the task has not been changed yet.',
  'chat.compound.batch_unchanged': 'This change has already been saved.',
  'chat.compound.batch_edit_title': 'Updated: task {ordinal} — title “{value}”.',
  'chat.compound.batch_edit_dueAt': 'Updated: task {ordinal} — due {value}.',
  'chat.compound.batch_edit_remove': 'The task for {label} was removed. {count} remaining.',
  'chat.compound.batch_choose_item':
    'Choose one task by its number or full record label. No changes were made.',
  'chat.compound.batch_relation_bound':
    'This task is bound to its source record. Its relation cannot be changed or removed; you can remove the whole task.',
  'chat.compound.batch_closed': 'This plan is already closed or superseded. No changes were made.',
  'chat.compound.batch_item_unavailable':
    'This task is no longer queued or awaiting approval. No changes were made.',
  'chat.compound.batch_field_clarification':
    'Specify one due date/time or one task title. No changes were made.',
  'chat.compound.batch_conflict':
    'The plan has changed. Refresh the chat and repeat the correction.',
  'chat.compound.batch_position': 'Position',
  'chat.compound.batch_position_value': '{position} of {count}',
  'chat.compound.batch_empty': 'No matching records. No tasks were prepared.',
  'chat.compound.batch_cap':
    'Found {count} records — above the limit of 10. Narrow the filter; no tasks were prepared.',
  'chat.compound.batch_unparsed':
    'The conditions could not be parsed unambiguously. Rephrase: "Find deals inactive for 30 days and prepare tasks «…» for each deal, except closed".',
  'chat.compound.batch_unsupported':
    'Not all conditions and prohibitions can be represented safely. Clarify the request; no tasks were prepared.',
  'chat.compound.step.analysis': 'Analysis',
  'chat.compound.step.prepare': 'Preparation',
  'ai_chat.action_plan.error.compound_source_changed':
    'The source record changed or is unavailable. This step was skipped; the remaining actions can continue.',
  'chat.compound.batch_already_approved': "The plan is already approved and can't be changed.",
  'ai_chat.action_plan.approve_remaining': 'Approve remaining ({count})',
  'ai_chat.action_plan.batch_group_stale': 'The plan has changed. Refresh the card.',
  'ai_chat.action_plan.batch_group_unavailable': 'Group approval is unavailable.',
  'ai_chat.action_plan.group_executing': 'Running…',
  'ai_chat.action_plan.group_pending': 'Pending',
  'ai_chat.action_plan.group_succeeded': 'Created',
  'ai_chat.action_plan.group_failed': 'Failed',
  'chat.planner_write.existing':
    'Using the existing record: {name}. The contact was not created or changed.',
  'chat.planner_write.not_applied': 'Not applied:',
  'chat.planner_write.field.firstName': 'First name',
  'chat.planner_write.field.lastName': 'Last name',
  'chat.planner_write.field.phone': 'Phone',
  'chat.planner_write.field.email': 'Email',
  'chat.planner_write.field.source': 'Source',
};
